import React, { useEffect, useState, useMemo, useRef } from "react";
// import { Badge } from "react-bootstrap";
import moment from "moment";
// import useScanDetection from 'use-scan-detection';

import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
// import ReactDOM from "react-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import FilterModal from "../../../components/Modal/FilterModal";
import Select from "react-select";
//import Toggle from "../../../common/Toggle";
import ReceivingCard from "../../../components/ReceivingCard/ReceivingCard";
import SuspendedConfirmation from "../../../components/Modal/SuspendedConfirmation";
import CancelConfirmation from "../../../components/Modal/CancelConfirmation";
import StoreAccountPaymentModal from "../../../components/Modal/StoreAccountPaymentModal";
import CompleteSaleModal from "../../../components/Modal/CompleteSalemodal";
import FileInput from "../../../components/FormControls/FileInput";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import ItemsDetailsModal from "../../../components/Modal/ItemsDetailsModal";
import { Closed, Expense, Noimage } from "../../../common/imagePath";
import { uploadAWS } from "../../../common/AWSHelper";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_RECEIVING,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
  CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE,
} from "../../../common/Constant";
import { checkUserPermission } from "../../../common/UserPermission";
import LookupReceiptModal from "../../../components/Modal/LookupReceiptModal";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import HistoryModel from "../../../components/Modal/HistoryModel";
// import { TemporaryCredentials } from "aws-sdk";

let counter = 0;
const ManageReceiving = () => {
  let navigate = useNavigate();

  // const [excelData, setExcelData] = useState(true);
  // const location = useLocation();
  //   console.log(location.state, "location.state 589");
  //  if(location.state.length > 0){
  //   setExcelData(location.state)
  //  }
  const qtyInputRef = useRef(null);
  const searchItemInputRef = useRef(null);

  let PERMISSION_DELETE = "receiving-batch-delete";
  let PERMISSION_EDIT = "/manage-receiving/:id";
  let PERMISSION_ADD = "/manage-receiving";
  let PERMISSION_RECEIPT = "/receiving-receipt/:id";
  let PERMISSION_PAYBILLS = "/receiving-paybills";
  let PERMISSION_TRANSFER = "/transfer-request/:id";
  let PERMISSION_INCOMING = "/suspended-receiving/:id";
  let PERMISSION_PURCHASE = "/create-purchase-orders";
  let PERMISSION_LASTRECEIVING = "/receiving-receipt";
  let PERMISSION_BATCHRECEIVING = "/batch-receiving";
  let PERMISSION_CUSTOMFIELD = "/receiving-custom-field";

  const urlSearchParams = new URLSearchParams(window.location.search);
  const location = useLocation();
  let pathname = location.pathname;
  console.log(pathname, "pathname1");
  const expenseParam = pathname.includes("/Expense");
  const isExpense = expenseParam ? true : false;

  console.log(isExpense, "isExpenseTrue");
  let originalPass = [];
  let matchedTagOptions;
  const paramObject = useParams();

  let totalRef = useRef(0);
  const Location = localStorage.getItem("Location");
  const Clone = localStorage.getItem("Clone")
    ? localStorage.getItem("Clone")
    : 0;
  console.log(Clone, "<===Clone");
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  // const [selectedterms, setSelectedTerms] = useState("");
  const [loading, setLoading] = useState(false);
  const [prevvalue, setprevvalue] = useState();
  const [check, setcheck] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [customFileUrl, setCustomFileUrl] = useState("");
  // const [validationErrors, setValidationErrors] = useState([]);
  const [changeImagename, setChangeImagename] = useState(false);
  const [commonDiscount, setCommonDiscount] = useState(0);
  const [supplierquickbookid, setSupplierQuickbookId] = useState(0);
  console.log(supplierquickbookid, "daatta====>"); // const [customership, setCustomerShip] = useState(0);
  // const [counter, setCounter] = useState(0); // initialize counter
  const [formValues, setFormValues] = useState({});
  const [payeequickbookid, setpayeequickbookid] = useState(0);
  console.log(payeequickbookid, "dayuyuyuyu");
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [accountrefquickbookid, setaccountrefquickbookid] = useState(0);
  const [selectedsupplier, setSelectedSupplier] = useState("");
  const [Expensedata, setExpensedata] = useState("");
  console.log(Expensedata, "datatatataa");
  const [supoptions, setSupOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [supplierName, setSupplierName] = useState();
  const [recevingquickbookid, setQuickbookidreceving] = useState(0);
  const [statenew, setStateNew] = useState([]);
  const [valuesprev, setvaluesprev] = useState();
  const [categoryStatenew, setCategoryStateNew] = useState([]);
  console.log(statenew,categoryStatenew,"54875");
  
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [entireReceivingDiscount, setEntireReceivingDiscount] = useState(0);
  const [discountInputValue, setDiscountInputValue] = useState(0);
  const [ReceivingType, setReceivingType] = useState(0);
  const [amountToSubtract, setAmountToSubtract] = useState(0);
  const [method, setMethod] = useState(["Cash"]); // Setting the payment Method.
  const [dueAmount, setDueAmount] = useState(0); // to keep track of all the DueAmount made
  const [payments, setPayments] = useState([]); // to keep track of all the payments made
  const [deletedPaymentIndex, setDeletedPaymentIndex] = useState(-1);
  // const [showDateInput, setShowDateInput] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState({
    id: 1,
    name: "Cash",
  });

  const [toggled, setToggled] = useState(false);

  const onToggle = () => {
    console.log(toggled, "444");
    setToggled((t) => !t);
  };
  // const [categoryAmount, setCategoryAmount] = useState("");
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [isTransfer, setIsTransfer] = useState("");
  const [select, setSelect] = useState("Receive");
  const [isStoreAccountPayment, setIsStoreAccountPayment] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldReceivingValues, setCustomFieldReceivingValues] = useState(
    []
  );
  // const [paymentValues, setPaymentValues] = useState([]);
  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [selectedCustomFile, setSelectedCustomFile] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [discountComment, setDiscountComment] = useState("");
  const [comment, setComment] = useState("");
  const [couponCode, setCouponCode] = useState("");
  // const [Suspend, setSuspend] = useState("");
  const [paymentCurrency, setPaymentCurrency] = useState("USD");
  const [receivingTypeDropdown, setReceivingTypeDropdown] = useState([]);
  const [paymentTypeDropdown, setPaymentTypeDropdown] = useState([]);
  const [suppliername, setsuppliername] = useState("");
  const [receivingTypeId, setReceivingTypeId] = useState(1);
  const [selectedReceiveOption, setSelectedReceiveOption] =
    useState("Purchase Order");

  const [isPo, setIsPo] = useState(1);
  const [isStoreAccountPaymentFlag, setIsStoreAccountPaymentFlag] = useState(0);
  const [supplierId, setSupplierId] = useState("");
  const [paidAmount, setPaidAmount] = useState("");

  console.log(supplierId, "supplierIdregjordfvjd");
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [customersDropdown, setCustomersDropdown] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  //const [shippingAddress, setShippingAddress] = useState("");

  const [termsDropdown, setTermsDropdown] = useState([]);
  const [tagsDropdown, setTagsDropdown] = useState([]);
  const [showTranser, setShowTranser] = useState();

  // const [selectedLocation, setSelectedLocation] = useState({ label: "", value: "", });
  // const [selectedTransferToLocation, setSelectedTransferToLocation] = useState({ label: "", value: "", });
  const [selectedLocation, setSelectedLocation] = useState();
  const [selectedTransferToLocation, setSelectedTransferToLocation] =
    useState();

  console.log(recevingquickbookid, "recevingquickbookid");

  const [refrenceno, setRefrenceno] = useState("");
  console.log(refrenceno, "2324");

  const [dueDate, setDueDate] = useState(moment().format(""));
  const [termsId, setTermsId] = useState(1);
  console.log(termsId , "termsId123")
  console.log(dueDate , "dueDate")
  const [TermsQuickbook, setTermsQuickbook] = useState("");

  //const [tags, setTags] = useState([]);
  const [selectedtags, setSelectedtags] = useState(""); //store seletcd tags

  const [accountId, setAccountId] = useState("");
  const [shipToCustomer, setShipToCustomer] = useState("");
  const [shippingAddressText, setshippingAddressText] = useState("");
  const [PayeeTypes, setPayeeTypes] = useState("");
  const [receivingquickbookid, setReceivingQuickbookId] = useState(0);

  console.log(paramObject.id, "paramObject");
  console.log(categoryStatenew, "categoryStatenew");
  console.log(statenew, "statenew99");
  console.log(accountId, "accountId");

  console.log(shippingAddressText, "shippingAddressText12");
  // const [supplierEmail, setSupplierEmail] = useState("");

  const [shipVia, setShipVia] = useState("");
  const [changeFileName, setChangeFileName] = useState(false);
  const [FileUrl, setFileUrl] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  // const [isExpense, setIsExpense] = useState(false);
  // const [isBill, setIsBill] = useState(false);
  // const [isCheck, setIsCheck] = useState(false);
  // const [isVendorCredit, setIsVendorCredit] = useState(false);
  const [selectedReceiveDropdown, setSelectedReceiveDropdown] = useState();
  const [balanceAmount, setBalanceAmount] = useState();
  console.log(selectedReceiveDropdown, "selectedreceive");

  const [emailsuppliers, setEmailsuppliers] = useState("");
  const [mailingAddress, setMailingAddress] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [balancesuppliers, setBalanceSuppliers] = useState("");

  const [addresssuppliers, setAddresssuppliers] = useState();

  const [todayDate, setTodayDate] = useState(moment(dueDate).format("YYYY-MM-DD"));
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryForSearch, setSelectedCategoryForSearch] =
    useState(null);
  const [receivingDate, setReceivingDate] = useState(todayDate);
  // const [balanceAmount, setBalanceAmount] = useState();
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [toggleItemsFilterSection, setToggleItemsFilterSection] =
    useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);

  // show Shipping Address editable
  const [shippingEditAddrerss, setShippingEditAddrerss] = useState(false);

  //show internal details
  const [showRowInternalDetails, setShowRowInternalDetails] = useState(true);

  //accordian

  console.log(receivingDate, "receivingDate123");

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };
  const [runApi, setRunApi] = useState(false);
  const [restirctedit, setRestrictEdit] = useState(0);
  const [payeeoptions, setPayeeOptions] = useState([]);
  const [payeeFilteredOptions, setPayeeFilteredOptions] = useState([]);
  const [showPayeeRquired, setShowPayeeRquired] = useState(false);

  //validation for transfer

  console.log(showPayeeRquired, "showPayeeRquired");

  const [showHistoryList, setShowHistoryList] = useState(false);
  const [transferFromLocation, setTransferFromLocation] = useState(false);
  const [transferToLocation, setTransferToLocation] = useState(false);
  const [payeetype, setPayeeType] = useState("");
  console.log(payeetype, "payeetype555");

  console.log(transferToLocation, "transferToLocation to 789");
  console.log(transferFromLocation, "transferFromLocation from 789");

  //LocalStorage
  // const[localValues,setLocalValues] = useState();
  const [localValues, setLocalValues] = useState({});

  // const addDaysToDate = (date, days) => {
  //   const currentDate = new Date(date);
  //   const dueDate = new Date(currentDate.setDate(currentDate.getDate() + days));
  //   // return dueDate.toISOString().split("T")[0];
  //   return moment(dueDate).format("yyyy-MM-DD");
  // };

  const addDaysToDate = (date, days) => {
    return moment(date).add(days, 'days').format("YYYY-MM-DD");
  };
  

  const today = moment();

  // const handleForCategorySearch = (event) => {
  //   console.log("selectedOptionselectedOption", event.value);
  //   setSelectedCategoryForSearch(event.value)
  // }
  const handleForCategorySearch = (event) => {
    if (event && event.value !== null) {
      setSelectedCategoryForSearch(event.value);
    } else {
      setSelectedCategoryForSearch(""); // or null, depending on your needs
    }
  };

  //Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color: "#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isActive ? "#000" : "#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };

  //For LocalStorage

  let LStotalAmt = JSON.parse(localStorage.getItem("receivingDraft"));
  LStotalAmt = LStotalAmt?.inputDropdown?.reduce((acc, cur) => {
    acc += +cur?.Total;

    return acc;
  }, 0);

  let amountForVendor = JSON.parse(localStorage.getItem("receivingDraft"));
  amountForVendor = amountForVendor?.expenseDropdown?.reduce((acc, cur) => {
    acc += +cur?.Total;

    return acc;
  }, 0);

  let LSItemtotalQty = JSON.parse(localStorage.getItem("receivingDraft"));
  LSItemtotalQty = LSItemtotalQty?.inputDropdown?.reduce((acc, cur) => {
    acc += +cur?.itemquantity;

    return acc;
  }, 0);

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    // Filter the data based on the search value
    const filteredItems = statenew.filter(
      (item) =>
        item.ItemName?.replace(" - ", " ")
          ?.toLowerCase()
          .includes(value?.toLowerCase()) ||
        item.VariationName?.replace(" - ", " ")
          ?.toLowerCase()
          .includes(value?.toLowerCase())
    );
    setFilteredData(filteredItems);
  };
  const [checkboxes, setCheckboxes] = useState(0);

  const vaidation = (name, value) => {
    switch (name) {
      case "Receipt":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });

    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "Receipt") {
          if (paramObject.id == undefined) {
            const x = {
              ...localValues,
              [isExpense ? "expAttachment" : "Attachment"]: data,
            };
            setLocalValues(x);
            localStorage.setItem("receivingDraft", JSON.stringify(x));
          }
          setFileUrl(data);
        }
      }
    });
  };

  console.log(statenew, "statenew");

  function handleChange(event) {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  }

  const handleFileChange = (event, index) => {
    setChangeFileName(true);
    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }
    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
          // setPreviewImage(images);
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };
  //show details row true false
  const handleShowDetails = (e) => {
    showRowInternalDetails
      ? setShowRowInternalDetails(false)
      : setShowRowInternalDetails(true);
  };

  const handleChangeAccountSalesData = (event, fieldName) => {
    let x;

    if (fieldName === "ShippingAddress") {
      x = {
        ...localValues,
        [isExpense ? "expShippingAddress" : fieldName]: event?.target?.value,
      };
      setshippingAddressText(event);
    }
    if (fieldName === "referenceno") {
      x = {
        ...localValues,
        [isExpense ? "expreferenceno" : fieldName]: event?.target?.value,
      };
      setRefrenceno(event.target.value);
    } else if (fieldName === "DueDate") {
      console.log(event?.target?.value, "event?.target?.value");
      x = { ...localValues, [fieldName]: event?.target?.value };

      setDueDate(event.target.value);
    } else if (fieldName === "TermsID") {
      console.log(event, "event123");
      const selectedTerm = termsDropdown.find(
        (term) => term.ID === event.value
      );
      const newDueDate = addDaysToDate(todayDate, selectedTerm.Value);
      x = {
        ...localValues,
        [fieldName]: event?.value,
        ["DueDate"]: newDueDate,
      };
      // setSelectedTerm(selectedTerm);
      setTermsId(event.value);
      setTermsQuickbook(event.QuickBookID);
      if (selectedTerm) {
        // const newDueDate = addDaysToDate(todayDate, selectedTerm.Value);
        handleChangeAccountSalesData(
          { target: { value: newDueDate } },
          "DueDate"
        );
      }
    }
    // else if (fieldName === "TermsID") {
    //   setTermsId(event.value);
    // }
    else if (fieldName === "Tags") {
      x = {
        ...localValues,
        [isExpense ? "expTags" : fieldName]: event.map((x) => x.value),
      };

      setSelectedtags(Array.isArray(event) ? event.map((x) => x.value) : []);
    } else if (fieldName === "AccountId") {
      x = {
        ...localValues,
        [fieldName]: event?.value,
        balanceAmount: event?.amount,
      };
      setAccountId(event?.value);
    } else if (fieldName === "ShipToCustomer") {
      x = {
        ...localValues,
        [isExpense ? "expShipToCustomer" : fieldName]: event?.value,
        [isExpense ? "expShippingAddress" : "ShippingAddress"]: event?.address,
      };
      setShipToCustomer(event.value);
      setshippingAddressText(event?.address);
    } else if (fieldName === "ShippingAddress") {
      x = {
        ...localValues,
        [isExpense ? "expShippingAddress" : fieldName]: event,
      };
      setshippingAddressText(event);
    } else if (fieldName === "receivingDate") {
      console.log(event?.target?.value, "receivingDate check");
      x = {
        ...localValues,
        [isExpense ? "expreceivingDate" : fieldName]: event?.target?.value,
      };

      // const datetime = moment(event[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // console.log(datetime, "event7410025896.3.......");
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      // setReceivingDate(settime);

    } else if (fieldName === "Email") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setEmailsuppliers(event.target.value);
    } else if (fieldName === "MailingAddress") {
      x = { ...localValues, [fieldName]: event?.target?.value };

      setAddresssuppliers(event.target.value);
    } else if (fieldName === "ShipVia") {
      x = {
        ...localValues,
        [isExpense ? "expShipVia" : fieldName]: event?.target?.value,
      };
      setShipVia(event.target.value);
    }
    if (paramObject.id === undefined) {
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    console.log("shipping address updated saveed to local");
  };

  const handleTotalChange = (index, value) => {
    updatedData = [...statenew];

    let totalvalue = value;
    let itemquantity = updatedData[index].itemquantity;
    let itemdiscount = updatedData[index].itemdiscount;
    if (itemdiscount == undefined || itemdiscount == "") {
      itemdiscount = 0;
    }

    // Calculate the subtotal after applying the discount
    let subtotal = totalvalue / (1 - itemdiscount / 100);

    // Calculate the price per quantity
    let price = subtotal / itemquantity;

    updatedData[index] = { ...updatedData[index], Total: value };
    updatedData[index] = { ...updatedData[index], CostPrice: price };

    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const paymentTypeMap = {};
  paymentTypeDropdown.forEach((paymentType) => {
    paymentTypeMap[paymentType.ID] = paymentType.Paymenttypename;
  });

  // location dropdown Binding.
  let locationDropdownOption = [];
  const locationDropdown = locationdropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  const handleTransferRequest = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/transferandincomingrequest?locationid=${Location}&status=TRANSFER`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("response.data.ResponseData[0]", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleTransferToRequest = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/transferandincomingrequest?locationid=${Location}&status=INCOMING`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("response.data.ResponseData[0]", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // handle Change for the location.
  const handleTransferToLocationChange = (e) => {
    const x = { ...localValues, transferLocationChange: e.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setTransferToLocation(true);
    setSelectedTransferToLocation(e.value);
  };

  // handle Change for the location.
  const handleLocationChange = (e) => {
    const x = { ...localValues, locationWarehouseDropdown: e.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setTransferFromLocation(true);
    // console.log("selectedOption ==>", e.value);
    setSelectedLocation(e.value);
  };

  const handlePayment = (method, id, name) => {
    setMethod(method);
    setSelectedPayment({ id, name });
  };
  console.log(categoryStatenew, "bankdata");

  //  For Dynamic Dropdown Receive Type
  const handleOptionSelect = (e, label, value) => {
    console.log(value,"7874");
    
    if (restirctedit == 1 && paramObject.id > 0) {
      setModal(true);
      return;
    } else if (
      paramObject.id > 0 &&
      value !== 1 &&
      value !== 2 &&
      value == 3 &&
      value !== 4 &&
      value == 5
    ) {
      //setvaluesprev(value)
      setStateNew([]);
      updateTotal([]);
      setEntireReceivingDiscount("");
      setSelectedPayment([]);
      setPayments([]);
      // setSelectedOption(null);
      setDueAmount(0);
      // handleSuspend([])
      setCategoryStateNew([]);
      // setShipVia("");
      // setAddresssuppliers();
      // setEmailsuppliers("");
      setBalanceSuppliers("");
      // setReceivingDate("");
      // setshippingAddressText("");
      setShipToCustomer("");
      setAccountId("");
      // setSelectedtags("");
      //setTermsId("");
      setDueDate("");
      // setRefrenceno("");
      setCommonDiscount("");
    } else {
      // setStateNew([]);
      // setCategoryStateNew([]);
      // if (prevvalue === 5) {
      //   setStateNew([]);
      // }
    }
    setprevvalue(value);
    toastWarn(`You are Changing to ${label}`);
    let x;
    //SettingUp Data in Local Storage
    if (paramObject.id === undefined) {
      if (value == 5 || value == 6 || value == 7) {
        x = {
          ...localValues,
          // inputDropdown: [],
          CommonDiscountLS: "",
          // DiscountChange: 0,
          // Comments: "",
          receivingDropdown: [value, label],
        };
        // setStateNew([]);
        // setCommonDiscount(0);
        // setDiscountComment();
        setEntireReceivingDiscount(0);
      } else {
        x = {
          ...localValues,
          // expenseDropdown: [],
          receivingDropdown: [value, label],
        };
        // setCategoryStateNew([]);
      }

      setLocalValues(x);
      console.log("remove13 1");
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

    setSelectedReceiveDropdown(value);

    let eve = e.target;
    const dataItemId = eve.getAttribute("value");
    const receiveType = dataItemId;
    setReceivingTypeId(value);
    setSelect(label);
    setIsTransfer(label === "Transfer");
    setIsStoreAccountPayment(label === "Supplier Account");
    const selectedOption = receivingTypeDropdownOption.find(
      (option) => option.value == receiveType
    );
    console.log(selectedOption, "Datafix=======>");
    let o = selectedOption.label;
    setSelectedReceiveOption(o);
    setReceivingType(selectedOption.value);

    setIsPo(1);
    if (receiveType != 1) {
      setIsPo(0);
    }

    setIsStoreAccountPaymentFlag(0);
    if (receiveType === 6) {
      setIsStoreAccountPaymentFlag(1);
    }
  };
  console.log(statenew, "data432");
  //console.log(statenew,"data432234");

  const handleCancelPopup = (pID) => {
    setStateNew([]);
    updateTotal([]);
    setEntireReceivingDiscount("");
    setSelectedOption(null);
    // setDueAmount([])
    setDueAmount(0);

    // setPayments([]);
    // setComment([])
  };

  const handleSuspend = (event) => {
    if (selectedReceiveDropdown === 5) {
      if (refrenceno) {
        setLoading(false);
      } else {
        // setLoading(true);
      }
    } else {
      // setLoading(true);
    }
    // setLoading(true);
    console.log("<====New Data 1");
    if (selectedReceiveDropdown === 7) {
      if (!accountId && showPayeeRquired && supplierId < 1) {
        toastError("Please select Payee and Account");
        setLoading(false);
        return;
      }
      console.log(supplierId, selectedsupplier, "check supplier data");

      if (!accountId) {
        toastError("Please select Account");
        setLoading(false);
        return;
      }
      if (showPayeeRquired && supplierId < 1) {
        toastError("Please select Payee");
        setLoading(false);
        return;
      }
    }
    // return
    if (selectedReceiveDropdown === 4) {
      if (!transferFromLocation) {
        toastError("Please select from location");
        setLoading(false);
        return;
      }
      if (!transferToLocation) {
        toastError("Please select to location");
        setLoading(false);
        return;
      }
    }
    let customFielddata = customFieldReceivingValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });
    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    const mappedItemDataArray = Itemdata.map((item) => ({
      ...item,
      Description: item.Description === null ? "" : item.Description,
    }));

    const isAccountReceivable = mappedItemDataArray.some(
      (el) => el.AccountTypeName === "Accounts Receivable"
    );
    const isAccountPayable = mappedItemDataArray.some(
      (el) => el.AccountTypeName === "Accounts Payable"
    );

    if (
      isAccountPayable &&
      isAccountReceivable &&
      selectedReceiveDropdown === 7
    ) {
      toastError(
        "You Con't add Accounts Receivable and Accounts Payable in same Expense"
      );
      return;
    }

    let p = payments;
    originalPass = p;

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    //
    // Create the payment object
    let paymentData = {};
    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    const Itemobj = {};
    Itemobj.receivingitemsXML = mappedItemDataArray; //Itemdata
    let itemjsonstring = JSON.stringify(Itemobj);

    let itemTotalSum = (mappedItemDataArray.reduce((sum, item) => sum + (item.Total || 0), 0)) - commonDiscount;

    console.log(itemTotalSum,"itemTotalSum");

    if (itemTotalSum != (selectedReceiveDropdown === 6
      ? parseFloat(paymentAmount)
      : paramObject.id !== undefined
      ? totalRef.current
      : selectedReceiveDropdown === 5 || selectedReceiveDropdown === 7
      ? amountForVendor
      : LStotalAmt - commonDiscount)){
        toast.error("Something went wrong please check receiving");
        return;
      }

    // For Custom Field Value
    let customValuesData = {};
    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    // console.log("customFielddata123",customFielddata)

    // //customFields Map
    // const customfield = {}
    // let customField = customFieldReceivingValues.map((item) => {
    //   // if(formValuesDataToSend[item.fieldName]!==undefined){
    //   console.log(item.CustomFieldValue, item.CustomFieldLabelID, "gsadhgshef")
    //   customfield[item.CustomFieldLabel] = item.CustomFieldValue
    //   // }
    // })
    // let customfieldvaluejsonstring = JSON.stringify(customfield);

    // console.log(customfield,"customFieldaaaaaa")
    // console.log(customfieldvaluejsonstring,"customFieldaaaaaa")

    // Create the form data object
    const formValuesDataToSend = {
      xmlreceivingsitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlpaymentvalue: paymentvaluejsonstring,
      // xmlcustomfield: customfieldvaluejsonstring,
      loginuserid: Id,
      // total: totalRef.current,
      // total:
      //   selectedReceiveDropdown === 6
      //     ? parseFloat(paymentAmount)
      //     : (paramObject.id!==undefined)?(totalRef.current):(LStotalAmt),
      total:
        selectedReceiveDropdown === 6
          ? parseFloat(paymentAmount)
          : paramObject.id !== undefined
          ? totalRef.current
          : selectedReceiveDropdown === 5 || selectedReceiveDropdown === 7
          ? amountForVendor
          : LStotalAmt - commonDiscount,
      subtotal:
        paramObject.id !== undefined
          ? totalRef.current
          : selectedReceiveDropdown === 5 || selectedReceiveDropdown === 7
          ? amountForVendor
          : LStotalAmt,
      comment: comment,
      id: paramObject.id || 0,
      supplierid: supplierId, // selectedOption.value,
      paymentcurreny: paymentCurrency,
      receivingtypeid: receivingTypeId,
      locationid: receivingTypeId == 4 ? selectedLocation : Location,
      // locationid: Location,
      // transfertolocationid: selectedTransferToLocation.value,
      transfertolocationid: selectedTransferToLocation,
      ispo: isPo,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: 0,
      totalquantityreceived: totalQuantity,
      discountcomment: discountComment,
      // discountentiresale: discountInputValue,
      discountentiresale: commonDiscount,
      addcouponcodes: couponCode,
      issuspended: 1,
      billno: refrenceno != "" && refrenceno != undefined ? refrenceno : 0,
      duedate: dueDate,
      termsid: termsId,
      termsquickbookid: TermsQuickbook,
      receipt: FileUrl,
      tagids: selectedtags != undefined ? selectedtags.toString() : "",
      accountid: accountId,
      shiptocustomer: shipToCustomer,
      shippingadress: shippingAddressText,
      shipvia: shipVia,
      receivingdate: receivingDate,
      supplieremail: emailsuppliers,
      mailingaddress: mailingAddress,
      balance: balanceAmount,
      IsComplete: 1,
      Payeetype:
        selectedReceiveDropdown === 7
          ? payeetype === "Supplier"
            ? 0
            : payeetype === "Customer"
            ? 1
            : payeetype === "Employee"
            ? 2
            : "test"
          : 0,
      customerdata: customersDropdownOption.find(
        (option) => option?.value == shipToCustomer
      ),
      supllierquickbookid: supplierquickbookid || 0,
      supplierName: suppliername,
      ReceivingId: recevingquickbookid,
      Shipingadd: mailingAddress,
      ReceivingTypes: ReceivingType,
      Accountrefquickbookid: accountrefquickbookid,
      payeequickbookid: payeequickbookid,
      receivingquickbookid: receivingquickbookid,
    };
    console.log(formValuesDataToSend, "formValuesDataToSend 3");
    // toastSuccess("Api Call Success")
    // return;  // upsert in table
    // Send the form data using axios
    setcheck(true);
    //   if (
    //     (selectedReceiveDropdown == 2 && !refrenceno) ||
    //     (selectedReceiveDropdown == 5 && !refrenceno)
    //   ) {
    //     toast.error("Please select reference number");
    //   } else {

    // };

    setLoading(true);
    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        //console.log(res);
        if (res.data.ResponseCode == "SUCCESS") {
          if (paramObject.id == undefined) {
            if (isExpense) {
              // localStorage.removeItem("receivingDraft");
              // receiving
              const x = {
                ...localValues,
                expenseDropdown: [],
                ExpenseSuppliers: null,
                Description: "",
                expTags: [],
                expreferenceno: "",
                expreceivingDate: "",
                AccountId: 0,
                balanceAmount: "",
                expbottomComments: "",
                expAttachment: "",
                expShippingAddress: "",
              };

              console.log("expance clear from the localStorage expense");
              setLocalValues(x);
              localStorage.setItem("receivingDraft", JSON.stringify(x));
            } else {
              // if(selectedReceiveDropdown === 5){
              //   const x = {
              //     ...localValues,
              //     expenseDropdown: [],
              //     ExpenseSuppliers: null,
              //     Description: "",
              //     expTags: [],
              //     expreferenceno: "",
              //     expreceivingDate: "",
              //     AccountId: 0,
              //     balanceAmount: "",
              //     expbottomComments: "",
              //     expAttachment: "",
              //     expShippingAddress: "",
              //   };

              //   console.log("expance clear from the localStorage");
              //   setLocalValues(x);
              //   localStorage.setItem("receivingDraft", JSON.stringify(x));
              // }else if (selectedReceiveDropdown === 4){
              //   const x = {
              //     ...localValues,
              //     inputDropdown: [],
              //     receivingDropdown: null,
              //     dropdownSuppliers: null,
              //     Tags: [],
              //     Attachment: "",
              //     receivingDate: "",
              //     referenceno: "",
              //     ShipToCustomer: 0,
              //     ShippingAddress: "",
              //     ShipVia: "",
              //     DiscountChange: 0,
              //     Comments: "",
              //     bottomComments: "",
              //     transferLocationChange: null,
              //     locationWarehouseDropdown: null
              //   };
              //   console.log("receiving clear from the localStorage");
              //   setLocalValues(x);
              //   localStorage.setItem("receivingDraft", JSON.stringify(x));
              // }else{
              //   const x = {
              //     ...localValues,
              //     inputDropdown: [],
              //     receivingDropdown: null,
              //     dropdownSuppliers: null,
              //     Tags: [],
              //     Attachment: "",
              //     receivingDate: "",
              //     referenceno: "",
              //     ShipToCustomer: 0,
              //     ShippingAddress: "",
              //     ShipVia: "",
              //     DiscountChange: 0,
              //     Comments: "",
              //     bottomComments: "",
              //   };
              //   console.log("receiving clear from the localStorage");
              //   setLocalValues(x);
              //   localStorage.setItem("receivingDraft", JSON.stringify(x));
              // }
              // expense

              if (selectedReceiveDropdown == 5) {
                const x = {
                  ...localValues,
                  receivingDropdown: null,
                  // ExpenseSuppliers: null,
                  Description: "",
                  Tags: [],
                  referenceno: "",
                  expreceivingDate: "",
                  AccountId: 0,
                  balanceAmount: "",
                  expbottomComments: "",
                  expAttachment: "",
                  expShippingAddress: "",
                  dropdownSuppliers: null,
                  bottomComments: "",
                  expenseDropdown: [],
                };
                console.log("receiving clear from the localStorage VC");
                setLocalValues(x);
                localStorage.setItem("receivingDraft", JSON.stringify(x));
              } else {
                const x = {
                  ...localValues,
                  inputDropdown: [],
                  receivingDropdown: null,
                  dropdownSuppliers: null,
                  Tags: [],
                  Attachment: "",
                  receivingDate: "",
                  referenceno: "",
                  ShipToCustomer: 0,
                  ShippingAddress: "",
                  ShipVia: "",
                  DiscountChange: 0,
                  Comments: "",
                  bottomComments: "",
                  transferLocationChange: null,
                  locationWarehouseDropdown: null,
                };
                console.log("receiving clear from the localStorage");
                setLocalValues(x);
                localStorage.setItem("receivingDraft", JSON.stringify(x));
              }
            }
          }
          localStorage.removeItem("Clone");
          toastSuccess(SUCCESS_MESSAGE);
          // setShowModal(true);

          navigate(`/receiving-receipt/${res.data.ResponseID}`);

          setStateNew([]);
          updateTotal([]);
          setEntireReceivingDiscount("");
          setSelectedPayment([]);
          setPayments([]);
          setSelectedOption(null);
          setDueAmount(0);
          // handleSuspend([])
          setCategoryStateNew([]);
          setShipVia("");
          setAddresssuppliers();
          setEmailsuppliers("");
          setBalanceSuppliers("");
          setReceivingDate("");
          setshippingAddressText("");
          setShipToCustomer("");
          setAccountId("");
          setSelectedtags("");
          //setTermsId("");
          setDueDate("");
          setRefrenceno("");
          setCommonDiscount("");
          // setDueAmount([])
          setLoading(false);
          // show the modal after form submission
          // window.location.reload();
        } else if (res.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        toastError(error);
        setLoading(false);
      });
  };

  console.log(supplierquickbookid, "supplierquickbookid");
  const handleIsComplete = (event) => {
    setLoading(true);

    if (selectedReceiveDropdown === 7) {
      if (!accountId) {
        toastError("Please select Account");
        setLoading(false);
        return;
      }
    }

    if (!transferFromLocation) {
      toastError("Please select from location");
      setLoading(false);
      return;
    }
    if (!transferToLocation) {
      toastError("Please select to location");
      setLoading(false);
      return;
    }

    let customFielddata = customFieldReceivingValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });
    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    let p = payments;
    originalPass = p;

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    const Itemobj = {};

    // For Custom Field Value
    let customValuesData = {};
    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    Itemobj.receivingitemsXML = Itemdata;
    let itemjsonstring = JSON.stringify(Itemobj);

    //
    // Create the payment object
    let paymentData = {};
    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    // Create the form data object
    const formValuesDataToSend = {
      xmlreceivingsitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlpaymentvalue: paymentvaluejsonstring,
      loginuserid: Id,

      // total: totalRef.current,
      total:
        selectedReceiveDropdown === 6
          ? parseFloat(paymentAmount)
          : paramObject.id !== undefined
          ? totalRef.current
          : LStotalAmt,
      // subtotal: totalRef.current,
      subtotal: paramObject.id !== undefined ? totalRef.current : LStotalAmt,
      comment: comment,
      // id: paramObject.id || 0,
      id: Clone ? 0 : paramObject.id ? paramObject.id : 0,
      supplierid: supplierId, // selectedOption.value,
      paymentcurreny: paymentCurrency,
      receivingtypeid: receivingTypeId,
      locationid: receivingTypeId == 4 ? selectedLocation : Location,
      // locationid: Location,
      // transfertolocationid: selectedTransferToLocation.value,
      transfertolocationid: selectedTransferToLocation,
      ispo: isPo,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: 0,
      totalquantityreceived: 0,
      discountcomment: discountComment,
      // discountentiresale: discountInputValue,
      discountentiresale: commonDiscount,
      addcouponcodes: couponCode,
      issuspended: 1,
      billno: refrenceno != "" && refrenceno != undefined ? refrenceno : 0,
      duedate: dueDate,
      termsid: termsId,
      termsquickbookid: TermsQuickbook,
      receipt: FileUrl,
      tagids: selectedtags != undefined ? selectedtags.toString() : "",
      accountid: accountId,
      shiptocustomer: shipToCustomer,
      shippingadress: shippingAddressText,
      shipvia: shipVia,
      receivingdate: receivingDate,
      supplieremail: emailsuppliers,
      mailingaddress: addresssuppliers,
      balance: balanceAmount,
      IsComplete: 0,
      customerdata: customersDropdownOption.find(
        (option) => option?.value == shipToCustomer
      ),
      supllierquickbookid: supplierquickbookid,
      supplierName: suppliername,
      ReceivingId: recevingquickbookid,
      Shipingadd: mailingAddress,
      ReceivingTypes: ReceivingType,
      Accountrefquickbookid: accountrefquickbookid,
      payeequickbookid: payeequickbookid,
      receivingquickbookid: receivingquickbookid,
      Payeetype:
        selectedReceiveDropdown === 7
          ? payeetype === "Supplier"
            ? 0
            : payeetype === "Customer"
            ? 1
            : payeetype === "Employee"
            ? 2
            : "test"
          : 0,
    };
    console.log(formValuesDataToSend, "formValuesDataToSend 1");
    // return;
    // Send the form data using axios
    //   if (
    //     (selectedReceiveDropdown == 2 && !refrenceno) ||
    //     (selectedReceiveDropdown == 5 && !refrenceno)
    //   ) {
    //     toast.error("Please select reference number");
    //   } else {

    // };

    setLoading(true);
    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          localStorage.removeItem("Clone");
          if (paramObject.id == undefined) {
            if (isExpense) {
              // localStorage.removeItem("receivingDraft");
              // receiving
              const x = {
                ...localValues,
                expenseDropdown: [],
                ExpenseSuppliers: null,
                Description: "",
                expTags: [],
                expreferenceno: "",
                expreceivingDate: "",
                AccountId: 0,
                balanceAmount: "",
                expbottomComments: "",
                expAttachment: "",
                expShippingAddress: "",
              };

              console.log("expance clear from the localStorage expense");
              setLocalValues(x);
              localStorage.setItem("receivingDraft", JSON.stringify(x));
            } else {
              // if(selectedReceiveDropdown === 5){
              //   const x = {
              //     ...localValues,
              //     expenseDropdown: [],
              //     ExpenseSuppliers: null,
              //     Description: "",
              //     expTags: [],
              //     expreferenceno: "",
              //     expreceivingDate: "",
              //     AccountId: 0,
              //     balanceAmount: "",
              //     expbottomComments: "",
              //     expAttachment: "",
              //     expShippingAddress: "",
              //   };

              //   console.log("expance clear from the localStorage");
              //   setLocalValues(x);
              //   localStorage.setItem("receivingDraft", JSON.stringify(x));
              // }else if (selectedReceiveDropdown === 4){
              //   const x = {
              //     ...localValues,
              //     inputDropdown: [],
              //     receivingDropdown: null,
              //     dropdownSuppliers: null,
              //     Tags: [],
              //     Attachment: "",
              //     receivingDate: "",
              //     referenceno: "",
              //     ShipToCustomer: 0,
              //     ShippingAddress: "",
              //     ShipVia: "",
              //     DiscountChange: 0,
              //     Comments: "",
              //     bottomComments: "",
              //     transferLocationChange: null,
              //     locationWarehouseDropdown: null
              //   };
              //   console.log("receiving clear from the localStorage");
              //   setLocalValues(x);
              //   localStorage.setItem("receivingDraft", JSON.stringify(x));
              // }else{
              //   const x = {
              //     ...localValues,
              //     inputDropdown: [],
              //     receivingDropdown: null,
              //     dropdownSuppliers: null,
              //     Tags: [],
              //     Attachment: "",
              //     receivingDate: "",
              //     referenceno: "",
              //     ShipToCustomer: 0,
              //     ShippingAddress: "",
              //     ShipVia: "",
              //     DiscountChange: 0,
              //     Comments: "",
              //     bottomComments: "",
              //   };
              //   console.log("receiving clear from the localStorage");
              //   setLocalValues(x);
              //   localStorage.setItem("receivingDraft", JSON.stringify(x));
              // }
              // expense

              if (selectedReceiveDropdown == 5) {
                const x = {
                  ...localValues,
                  receivingDropdown: null,
                  // ExpenseSuppliers: null,
                  Description: "",
                  Tags: [],
                  referenceno: "",
                  expreceivingDate: "",
                  AccountId: 0,
                  balanceAmount: "",
                  expbottomComments: "",
                  expAttachment: "",
                  expShippingAddress: "",
                  dropdownSuppliers: null,
                  bottomComments: "",
                  expenseDropdown: [],
                };
                console.log("receiving clear from the localStorage VC");
                setLocalValues(x);
                localStorage.setItem("receivingDraft", JSON.stringify(x));
              } else {
                const x = {
                  ...localValues,
                  inputDropdown: [],
                  receivingDropdown: null,
                  dropdownSuppliers: null,
                  Tags: [],
                  Attachment: "",
                  receivingDate: "",
                  referenceno: "",
                  ShipToCustomer: 0,
                  ShippingAddress: "",
                  ShipVia: "",
                  DiscountChange: 0,
                  Comments: "",
                  bottomComments: "",
                  transferLocationChange: null,
                  locationWarehouseDropdown: null,
                };
                console.log("receiving clear from the localStorage");
                setLocalValues(x);
                localStorage.setItem("receivingDraft", JSON.stringify(x));
              }
            }
          }
          toastSuccess(SUCCESS_MESSAGE);
          setShowModal(true);
          // navigate(`/receiving`);
          navigate(`/receiving-receipt/${res.data.ResponseID}`);

          // setStateNew([]);
          // updateTotal([]);
          // setEntireReceivingDiscount([]);
          // setSelectedPayment([]);
          // setPayments([]);
          // setSelectedOption(null);
          // setDueAmount(0);
          // // handleSuspend([])
          // setCategoryStateNew([]);
          // setShipVia("");
          // setAddresssuppliers();
          // setEmailsuppliers("");
          // setBalanceSuppliers("");
          // setReceivingDate("");
          // setshippingAddressText("");
          // setShipToCustomer("");
          // setAccountId("");
          // setSelectedtags("");
          // setTermsId("");
          // setDueDate("");
          // setRefrenceno("");
          // setCommonDiscount([]);
          // setDueAmount([])
          setLoading(false);
          // show the modal after form submission
          // window.location.reload();
        } else if (res.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        toastError(error);
        setLoading(false);
      });
  };

  const handleDeletePayment = (index) => {
    setDeletedPaymentIndex(index);
    let prevDueAmount =
      parseFloat(dueAmount) + parseFloat(payments[index].PaymentAmount);
    setDueAmount(prevDueAmount);
    setPayments(payments.filter((payment, i) => i !== index)); // Remove the deleted payment from the payments array
    setDeletedPaymentIndex(-1); // Reset the deletedPaymentIndex state
  };

  console.log(termsId, "receivingquickbookid000==>");
  const handleSubmit = (event) => {
    let customFielddata = customFieldReceivingValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });

    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    const Itemobj = {};

    // For Custom Field Value
    let customValuesData = {};
    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    Itemobj.receivingitemsXML = Itemdata;
    let itemjsonstring = JSON.stringify(Itemobj);

    // Create the payment object
    let paymentData = {};
    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    // Create the form data object
    const formValuesDataToSend = {
      xmlreceivingsitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlpaymentvalue: paymentvaluejsonstring,
      loginuserid: Id,

      // total: totalRef.current,
      total:
        selectedReceiveDropdown === 6
          ? parseFloat(paymentAmount)
          : paramObject.id !== undefined
          ? totalRef.current
          : LStotalAmt,
      subtotal: paramObject.id !== undefined ? totalRef.current : LStotalAmt,
      comment: comment,
      id: Clone > 0 ? 0 : paramObject.id || 0,
      supplierid: supplierId, //selectedOption.value,
      paymentcurreny: paymentCurrency,
      receivingtypeid: receivingTypeId,
      //locationid: receivingTypeId == 6 ? Location : selectedLocation,
      locationid: Location,
      // transfertolocationid: selectedTransferToLocation.value,
      transfertolocationid: selectedTransferToLocation,
      ispo: isPo,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: 0,
      totalquantityreceived: 0,
      discountcomment: discountComment,
      // discountentiresale: discountInputValue,
      discountentiresale: commonDiscount,
      addcouponcodes: couponCode,
      issuspended: 0,
      billno: refrenceno != "" && refrenceno != undefined ? refrenceno : 0,
      duedate: dueDate,
      termsid: termsId,
      termsquickbookid: TermsQuickbook,
      receipt: FileUrl,
      tagids: selectedtags != undefined ? selectedtags.toString() : "",
      accountid: accountId,
      shiptocustomer: shipToCustomer,
      shippingadress: shippingAddressText,
      shipvia: shipVia,
      receivingdate: receivingDate,
      supplieremail: emailsuppliers,
      mailingaddress: addresssuppliers,
      balance: balanceAmount,
      customerdata: customersDropdownOption.find(
        (option) => option?.value == shipToCustomer
      ),
      supllierquickbookid: supplierquickbookid,
      supplierName: suppliername,
      ReceivingId: recevingquickbookid,
      Shipingadd: mailingAddress,
      ReceivingTypes: ReceivingType,
      Accountrefquickbookid: accountrefquickbookid,
      receivingquickbookid: receivingquickbookid,
      payeequickbookid: payeequickbookid,
      Payeetype:
        selectedReceiveDropdown === 7
          ? payeetype === "Supplier"
            ? 0
            : payeetype === "Customer"
            ? 1
            : payeetype === "Employee"
            ? 2
            : "test"
          : 0,
    };
    console.log(formValuesDataToSend, "formValuesDataToSend 2");
    // return;
    //   Send the form data using axios

    //   if (
    //     (selectedReceiveDropdown == 2 && !refrenceno) ||
    //     (selectedReceiveDropdown == 5 && !refrenceno)
    //   ) {
    //     toast.error("Please select reference number");
    //   } else {

    // };

    setLoading(true);
    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          localStorage.removeItem("Clone");

          const initialValues = {
            ...localValues,
            expenseDropdown: [],
            Description: "",
            Tags: [],
            referenceno: "",
            expreceivingDate: "",
            AccountId: 0,
            balanceAmount: "",
            bottomComments: "",
            expAttachment: "",
            expShippingAddress: "",
          };

          if (paramObject.id === undefined) {
            if (isExpense) {
              const expenseValues = {
                ...initialValues,
                ExpenseSuppliers: null,
                expTags: [],
              };
              console.log("Expense cleared from localStorage");
              setLocalValues(expenseValues);
              localStorage.setItem(
                "receivingDraft",
                JSON.stringify(expenseValues)
              );
            } else {
              let receivingValues;

              if (selectedReceiveDropdown === 5) {
                receivingValues = {
                  ...initialValues,
                  receivingDropdown: null,
                  dropdownSuppliers: null,
                };
                console.log("Receiving cleared from localStorage VC");
              } else {
                receivingValues = {
                  ...initialValues,
                  inputDropdown: [],
                  receivingDropdown: null,
                  dropdownSuppliers: null,
                  receivingDate: "",
                  ShipToCustomer: 0,
                  ShippingAddress: "",
                  ShipVia: "",
                  DiscountChange: 0,
                  Comments: "",
                  transferLocationChange: null,
                  locationWarehouseDropdown: null,
                };
                console.log("Receiving cleared from localStorage");
              }
              setLocalValues(receivingValues);
              localStorage.setItem(
                "receivingDraft",
                JSON.stringify(receivingValues)
              );
            }
          }

          toastSuccess(SUCCESS_MESSAGE);
          setShowModal(true);
          setLoading(false);
          navigate(`/receiving-receipt/${res.data.ResponseID}`);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        toastError(error.message);
        setLoading(false);
      });
  };

  const handleCompleteSale = (salestatus) => {
    const amount = parseFloat(amountToSubtract);

    if (salestatus === "complete") {
      if (!amountToSubtract) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (isNaN(amount) || amount <= 0) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (amount > dueAmount) {
        // display error message
        toast.error("The amount entered is greater than the due amount");
        return;
      }
    }

    if (dueAmount > 0 || salestatus === "suspend") {
      // add payment method only if amount due is greater than zero
      // if (isNaN(amount) || amount <= 0) {
      //   // display error message
      //   toast.error("Please enter a valid amount");
      //   return;
      // }
      let payment = {
        PayId: 0,
        PaymentId: selectedPayment.id,
        PaymentAmount: amount,
      };

      let updatedPayments = [...payments];
      if (amount > 0) {
        updatedPayments.push(payment);
      }

      setPayments(updatedPayments);

      originalPass = updatedPayments;
      setDueAmount((prevDueAmount) => prevDueAmount - amount);

      setAmountToSubtract("");
    }
  };

  const handleAmountChange = (event) => {
    let amount = parseFloat(event.target.value);
    if (Number.isNaN(amount)) {
      amount = 0;
    }
    // setAmountToSubtract(event.target.value);
    setAmountToSubtract(amount);
  };

  // it will call when the filter is clicked in the popup
  const callback = (payload) => {
    console.log(payload, "datas===>");
    if (payload != undefined && payload.length > 0) {
      // const newItem = { ...payload[0], itemquantity: 1, UnitPrice: 0 };
      const newItem = {
        ...payload[0],
        itemquantity: 1,
        receivingitemquickbookid: 0,
        ReceivingId: paramObject?.id ? paramObject?.id : 0,
      };
      const existingItemIndex = statenew?.findIndex(
        (item) =>
          item.VariationId === newItem.VariationId &&
          item.ItemId === newItem.ItemId
      );
      if (existingItemIndex !== -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity = existingItem.itemquantity + 1;
        existingItem.Total = calculateTotal(
          existingItem.CostPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );

        const updatedDataNew = [...statenew];
        updatedDataNew.splice(existingItemIndex, 1);

        console.log(updatedDataNew, "0520 2");
        console.log([existingItem, ...updatedDataNew], "0520 2");

        // updatedDataNew[existingItemIndex] = existingItem; //29082024
        setStateNew([existingItem, ...updatedDataNew]);
        setCategoryStateNew([existingItem, ...updatedDataNew]);
        setTimeout(() => {
          if (qtyInputRef.current) {
            qtyInputRef.current.focus();
          }
        }, 0);

        // updatedDataNew[existingItemIndex] = existingItem;
        // setStateNew(updatedDataNew);
        // setCategoryStateNew(updatedDataNew); //29082024
        updatedData = updatedDataNew;
      } else {
        setStateNew([newItem, ...statenew]);
        updatedData = statenew.concat(newItem); // add the new item to updatedData
        setTimeout(() => {
          if (qtyInputRef.current) {
            qtyInputRef.current.focus();
            qtyInputRef.current.select();
          }
        }, 0);
      }

      // add the following code to store items whose Module is "Accounts"
      let categoryItems = [];
      for (let i = 0; i < updatedData.length; i++) {
        const item = updatedData[i];
        if (item.Module === "Accounts") {
          categoryItems.push(item);
        }
      }

      setCategoryStateNew(categoryItems);
      updateTotal(updatedData); // pass updatedData to updateTotal()
    }
    payload = "";
  };

  const callbackItemGrid = (payload) => {
    setRunApi(false);
    // const newItem = { ...payload[0], itemquantity: 1 };
    console.log(payload, "payload");
    // Loop over each item in the payload array
    payload.forEach((newItem) => {
      // Find the index of the item in the statenew array that has the same ItemId
      // const index = statenew.findIndex(
      //   (i) => i.VariationId === item.VariationId
      // );

      const existingItemIndex = statenew.findIndex(
        (item) =>
          item.VariationId === newItem.VariationId &&
          item.ItemId === newItem.ItemId
      );
      if (existingItemIndex !== -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity += 1;
        existingItem.Total = calculateTotal(
          existingItem.CostPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );

        const updatedDataNew = [...statenew];
        updatedDataNew[existingItemIndex] = existingItem;
        updatedData = updatedDataNew;
      } else {
        newItem.itemdiscount = 0;
        newItem.ItemCurrentQuantity =
          newItem?.VariationId || newItem?.VariationId < 0
            ? newItem?.VariationQuantity
            : newItem?.Itemquantity;
        // Otherwise, add the item with itemquantity 1 to the statenew array
        statenew.push({
          ...newItem,
          itemquantity: 1,
          ReceivingId: paramObject?.id > 0 ? paramObject?.id : 0,
          Total: calculateTotal(newItem.CostPrice, 1, 0),
        });
        updatedData = statenew.concat({
          ...newItem,
          itemquantity: 1,
          ReceivingId: paramObject?.id > 0 ? paramObject?.id : 0,
          Total: calculateTotal(newItem.CostPrice, 1, 0),
        });
        // setStateNew([...statenew, newItem]);
        // updatedData = statenew.concat(newItem); // add the new item to updatedData
      }
    });

    setStateNew(updatedData);
    setStateNew([...statenew]);
    updateTotal(statenew);
    // updateTotal(updatedData);

    //console.log("item ==> updatedData: 1", updatedData);
    // updateTotal(updatedData);

    // setStateNew([...statenew, newItem]);
    // setCategoryStateNew([...categoryStatenew, newItem]);
    // updatedData = statenew.concat(newItem); // add the new item to updatedData

    // // setStateNew(updatedData);

    // // setStateNew([...statenew,]);
    // updateTotal(updatedData);
  };
  //
  const callbackMailingAddress = (payload) => {
    setMailingAddress(payload);
    console.log(payload, "datatesting==>");
  };

  function calculateTotal(CostPrice, itemquantity, itemdiscount) {
    // const item = statenew[index];
    if (isNaN(CostPrice)) {
      CostPrice = 0;
    }
    if (isNaN(itemquantity)) {
      itemquantity = 0;
    }
    if (isNaN(itemdiscount)) {
      itemdiscount = 0;
    }
    const totalPrice = CostPrice * itemquantity * (1 - itemdiscount / 100);

    return totalPrice;
  }

  const handleCancelClick = (event) => {
    event?.preventDefault();
    setSelectedOption(null);
    setEmailsuppliers(null);
    setBalanceSuppliers(null);
    setAddresssuppliers(null);
    setSelectedCustomer([]);
    setSupplierId(0);
    setpayeequickbookid(0);

    if (shipToCustomer == "") {
      setshippingAddressText("");
    }
    // setSelectedOption(null);
    // setComment(null)
  };

  const handleEntireReceivingDiscountChange = (event) => {
    const newDiscountValue = Number(event.target.value);
    //setting Value in LS
    const x = { ...localValues, DiscountChange: newDiscountValue };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setEntireReceivingDiscount(
      isNaN(newDiscountValue) || newDiscountValue == 0 ? 0 : newDiscountValue
    );

    setDiscountInputValue(newDiscountValue == 0 ? "" : newDiscountValue);

    const updatedDataDiscount = statenew.map((item) => {
      let total = calculateTotal(
        item.CostPrice,
        item.itemquantity,
        newDiscountValue
      );
      return { ...item, itemdiscount: newDiscountValue, Total: Number(total) };
    });

    setStateNew(updatedDataDiscount);
    updatedData = updatedDataDiscount;

    updateTotal(updatedData);
  };

  const handleChangeComment = (e) => {
    const x = {
      ...localValues,
      [isExpense ? "expbottomComments" : "bottomComments"]: e?.target?.value,
    };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setComment(e.target.value);
  };

  //comments HandleChanges
  const handleChangeDiscountComments = (e) => {
    //setting up the data in LS
    const x = { ...localValues, Comments: e?.target?.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setDiscountComment(e?.target?.value);
  };

  const handleChangeCupon = (e) => {
    setCouponCode(e.target.value);
  };

  //dropdown
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };
  useEffect(() => {
    if (selectedsupplier) {
      // let DueDate = new Date(todayDate);
      // DueDate.setDate(DueDate.getDate() + selectedsupplier?.TermDay);
      setTermsId(selectedsupplier.Terms == 0 ? 1 : selectedsupplier.Terms);
      // , moment(DueDate).format("YYYY-MM-DD"))
      setDueDate(addDaysToDate(todayDate, selectedsupplier?.TermDay));
    }
  }, [selectedsupplier]);

  console.log(supoptions, "supplierdata==>");
  const options = supoptions.map((option) => ({
    value: option.ID,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    email: option.Email,
    // address: (option?.Address1!=""
    //   ? option?.Address1 + " "
    //   : "") +
    // (option?.Address2!=""
    //   ? option?.Address2 + ", "
    //   : "") +
    // (option?.City!=""  ? option?.City + ", " : "") +
    // (option?.StateProvince!=""
    //   ? option?.StateProvince + ", "
    //   : "") +
    // (option?.Country!=""  ? option?.Country + ", " : "") +
    // (option?.Zip!=""  ? option?.Zip + "" : ""),
    address: option.address,
    balance: option.Balance,
    image: option.Image,
    supplierquickbookIds: option.QuickBookId,
    customerquicbookids: option.QuickbookID,
    suppliernames: option.FirstName,
    Module: "Recevings",
  }));

  const optionspayee = payeeoptions.map((option) => ({
    value: option.ID,
    label:
      option.Type == "Employee" // Customer, Supplier
        ? option.FirstName + " " + option.LastName + "-" + option.Type
        : option.CompanyName +
          " (" +
          (option.FirstName + " " + option.LastName) +
          ")" +
          "-" +
          option.Type,
    email: option.Email,
    address: option.Address,
    balance: option.Balance,
    image: option.Image,
    type: option.Type,
    Quickbookid: option.QuickBookId,
    Module: "Expense",
  }));

  useEffect(() => {
    if (receivingTypeId === 7) {
      console.log(statenew, "ergfvhref43");
      const isAccountReceivable = statenew?.some(
        (el) => el.AccountTypeName === "Accounts Receivable"
      );
      console.log(isAccountReceivable, "isAccountReceivable123");
      const isAccountPayable = statenew?.some(
        (el) => el.AccountTypeName === "Accounts Payable"
      );
      setShowPayeeRquired(isAccountPayable || isAccountReceivable);
      console.log(isAccountPayable, isAccountReceivable, "check dropdown");

      if (isAccountPayable && isAccountReceivable) {
        // setPayeeFilteredOptions(optionspayee1);
        handleCancelClick();
      } else if (isAccountPayable) {
        const optionspayee1 = optionspayee.filter(
          (el) => el.type === "Supplier"
        );
        setPayeeFilteredOptions(optionspayee1);
        if (payeetype !== "Supplier") {
          handleCancelClick();
        }
      } else if (isAccountReceivable) {
        const optionspayee1 = optionspayee.filter(
          (el) => el.type === "Customer"
        );
        setPayeeFilteredOptions(optionspayee1);
        if (payeetype !== "Customer") {
          handleCancelClick();
        }
      } else {
        setPayeeFilteredOptions(optionspayee);
        console.log(optionspayee, "check dropdown");
      }
    }
  }, [statenew, payeeoptions]);

  console.log(payeeFilteredOptions, "payeeFilteredOptions");

  //Supplier dropdown
  const handleSelectChange = (event) => {
    console.log(event, "===event");
    setpayeequickbookid(event?.Quickbookid);
    setPayeeType(event?.type);
    if (isExpense) {
      let x = { ...localValues, ExpenseSuppliers: event };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    } else {
      let x = { ...localValues, dropdownSuppliers: event };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

    setSelectedOption(event);
    setEmailsuppliers(event.email);
    setSupplierId(event.value);
    setBalanceSuppliers(event.balance);
    setAddresssuppliers(event.address);
    // setMailingAddress(event.address);
    // Reset the supplierId to avoid showing the previous card
    // Temporary Commented Supplier Get by Id
    if (isExpense) {
      axios
        .get(
          `${config.generalBaseUrl}/generals/payeedetailforlabel?payeeid=${event.value}&type=${event.type}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (
            response.data.ResponseData[0] != undefined &&
            response.data.ResponseData[0] != null
          ) {
            let supplierData = response.data.ResponseData[0];
            console.log(supplierData.Address1, "quickbook===>");
            setSupplierQuickbookId(supplierData.QuickbookID);
            setsuppliername(supplierData.CompanyName);
            setSelectedSupplier(supplierData);
            // setExpensedata(supplierData);

            const PayeeType =
              event.type === "Supplier" ? 0 : event.type === "Customer" ? 1 : 2;
            const Expensedata = { ...supplierData, PayeeType };
            setExpensedata(Expensedata);

            // if (event.Module == "Expense") {
            //   let x = { ...localValues, ExpenseSuppliers: supplierData };
            //   setLocalValues(x);
            //   localStorage.setItem("receivingDraft", JSON.stringify(x));
            // }

            // let supplierAddress =
            //   supplierData.Address1 +
            //   " " +
            //   supplierData.Address2!="" ?  supplierData.Address2 +",\r\n": "" +
            //   supplierData.City!=""?   supplierData.City +",\r\n": "" +
            //   supplierData.StateProvince!=""? supplierData.StateProvince +",\r\n": ""  +
            //   supplierData.Country!=""?  supplierData.Country +",\r\n": "" +
            //   supplierData.Zip;

            // let addressComponents = [];
            // if (supplierData.Address1)
            //   addressComponents.push(supplierData.Address1);
            // if (supplierData.Address2)
            //   addressComponents.push(supplierData.Address2);
            // if (supplierData.City) addressComponents.push(supplierData.City);
            // if (supplierData.State) addressComponents.push(supplierData.State);
            // if (supplierData.Country)
            //   addressComponents.push(supplierData.Country);
            // if (supplierData.Zip) addressComponents.push(supplierData.Zip);

            let supplierAddress =
              (supplierData.Address1 ? supplierData.Address1 + " " : "") +
              (supplierData.Address2 ? supplierData.Address2 + ",\r\n" : "") +
              (supplierData.City ? supplierData.City + ",\r\n" : "") +
              (supplierData.State ? supplierData.State + ",\r\n" : "") +
              (supplierData.Country ? supplierData.Country + ",\r\n" : "") +
              (supplierData.Zip ? supplierData.Zip + ".\r\n" : "");

            setMailingAddress(supplierAddress);
            setshippingAddressText(supplierAddress);

            // setMailingAddress(supplierAddress);

            // setSelectedOption("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get(
          `${config.suppliersBaseUrl}/suppliers/supplierdetailforlabel?supplierids=${event.value}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (
            response.data.ResponseData[0] != undefined &&
            response.data.ResponseData[0] != null
          ) {
            let supplierData = response.data.ResponseData[0];
            console.log(supplierData, "quickbook===>");
            setSupplierQuickbookId(supplierData.QuickbookID);
            setsuppliername(supplierData.CompanyName);
            setSelectedSupplier(supplierData);

            let supplierAddress =
              (supplierData.Address1 ? supplierData.Address1 + " " : "") +
              (supplierData.Address2 ? supplierData.Address2 + ",\r\n" : "") +
              (supplierData.City ? supplierData.City + ",\r\n" : "") +
              (supplierData.State ? supplierData.State + ",\r\n" : "") +
              (supplierData.Country ? supplierData.Country + ",\r\n" : "") +
              (supplierData.Zip ? supplierData.Zip + ".\r\n" : "");

            setMailingAddress(supplierAddress);

            setshippingAddressText(supplierAddress);

            // setSelectedOption("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  console.log(payeequickbookid, "payeequickbookid==>>");
  console.log(mailingAddress, "mailingaddress===>");
  console.log(selectedsupplier, "selectedSupplier===>");

  //Persisiting the data in the Local Storage of Suppliers
  const handleDataChange = (sId, parsedData) => {
    if (isExpense) {
      axios
        .get(
          `${config.generalBaseUrl}/generals/payeedetailforlabel?payeeid=${sId}&type=${parsedData?.ExpenseSuppliers?.type}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (
            response.data.ResponseData[0] != undefined &&
            response.data.ResponseData[0] != null
          ) {
            let supplierData = response.data.ResponseData[0];
            console.log(supplierData.Address1, "quickbook===>");
            setSupplierQuickbookId(supplierData.QuickbookID);
            setsuppliername(supplierData.CompanyName);
            setSelectedSupplier(supplierData);
            setExpensedata(supplierData);

            // console.log(supplierData, "datatatataa 124")
            // const PayeeType =
            //   parsedData?.ExpenseSuppliers?.type === "Supplier"
            //     ? 0
            //     : parsedData?.ExpenseSuppliers?.type === "Customer"
            //     ? 1
            //     : 2;
            // const Expensedata = { ...supplierData, PayeeType };
            // setSelectedSupplier(Expensedata);
            // setExpensedata(Expensedata);

            // console.log(Expensedata, "datatatataa 123")

            // if (event.Module == "Expense") {
            //   let x = { ...localValues, ExpenseSuppliers: supplierData };
            //   setLocalValues(x);
            //   localStorage.setItem("receivingDraft", JSON.stringify(x));
            // }

            // let supplierAddress =
            //   supplierData.Address1 +
            //   " " +
            //   supplierData.Address2!="" ?  supplierData.Address2 +",\r\n": "" +
            //   supplierData.City!=""?   supplierData.City +",\r\n": "" +
            //   supplierData.StateProvince!=""? supplierData.StateProvince +",\r\n": ""  +
            //   supplierData.Country!=""?  supplierData.Country +",\r\n": "" +
            //   supplierData.Zip;

            // let addressComponents = [];
            // if (supplierData.Address1)
            //   addressComponents.push(supplierData.Address1);
            // if (supplierData.Address2)
            //   addressComponents.push(supplierData.Address2);
            // if (supplierData.City) addressComponents.push(supplierData.City);
            // if (supplierData.State) addressComponents.push(supplierData.State);
            // if (supplierData.Country)
            //   addressComponents.push(supplierData.Country);
            // if (supplierData.Zip) addressComponents.push(supplierData.Zip);

            let supplierAddress =
              (supplierData.Address1 ? supplierData.Address1 + " " : "") +
              (supplierData.Address2 ? supplierData.Address2 + ",\r\n" : "") +
              (supplierData.City ? supplierData.City + ",\r\n" : "") +
              (supplierData.State ? supplierData.State + ",\r\n" : "") +
              (supplierData.Country ? supplierData.Country + ",\r\n" : "") +
              (supplierData.Zip ? supplierData.Zip + ".\r\n" : "");

            setMailingAddress(supplierAddress);
            setshippingAddressText(supplierAddress);

            // setMailingAddress(supplierAddress);

            // setSelectedOption("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get(
          `${config.suppliersBaseUrl}/suppliers/supplierdetailforlabel?supplierids=${sId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (
            response.data.ResponseData[0] != undefined &&
            response.data.ResponseData[0] != null
          ) {
            let supplierData = response.data.ResponseData[0];
            setSelectedSupplier(supplierData);

            let supplierAddress =
              (supplierData.Address1 ? supplierData.Address1 + " " : "") +
              (supplierData.Address2 ? supplierData.Address2 + ",\r\n" : "") +
              (supplierData.City ? supplierData.City + ",\r\n" : "") +
              (supplierData.State ? supplierData.State + ",\r\n" : "") +
              (supplierData.Country ? supplierData.Country + ",\r\n" : "") +
              (supplierData.Zip ? supplierData.Zip + ".\r\n" : "");
            setMailingAddress(supplierAddress);
            if (
              parsedData.ShipToCustomer == undefined &&
              parsedData.ShippingAddress == undefined
            ) {
              setshippingAddressText(supplierAddress);
            } else if (parsedData.ShipToCustomer > 0) {
              setshippingAddressText(parsedData.ShippingAddress);
            } else {
              setshippingAddressText(parsedData.ShippingAddress);
            }
            // setSelectedOption("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  //Batch Receiving getData

  // For Receiving Type Dropdown
  let receivingTypeDropdownOption = [];
  const RolesDropdown = receivingTypeDropdown
    .filter((el) => el.ReceivingsType !== "Expense")
    .map((u, i) => {
      receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
    });

  console.log(receivingTypeDropdownOption, "receivingTypeDropdownOption");
  // for AccountID
  let accountTypeDropdownOption = [];
  const AccountDropdown = chartOfAccountDropdown.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
      quickbookid: u.QuickbookId,
    };
  });

  console.log(accountTypeDropdownOption, "accountTypeDropdownOption");
  // For Customers
  let customersDropdownOption = [];
  const CustomersDropdown = customersDropdown.map((u, i) => {
    customersDropdownOption[i] = {
      // label: u.FirstName,
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.Id,
      address:
        u.Address1 +
        " " +
        u.Address2 +
        ",\r\n" +
        u.City +
        ",\r\n" +
        u.StateProvince +
        ",\r\n" +
        u.Country +
        ".\r\n" +
        u.Zip,
      quickbookid: u.QuickbookID,
    };
  });

  // For Terms
  let termsDropdownOption = [];
  const TermsDropdown = termsDropdown.map((u, i) => {
    termsDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      days: u.Value,
      QuickBookID: u.QuickBookID,
    };
  });

  // For Tags
  let tagsDropdownOption = [];
  const tagstypeDropdown = tagsDropdown.map((u, i) => {
    tagsDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  // For Categories
  let categoryDropdownOption = [];
  const categorytypeDropdown = selectedCategory.map((u, i) => {
    categoryDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const BindPageDropDown = () => {
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedCategory(res.data.ResponseData);
      });

    // Accounting Tags Drop Down Axios Call
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // Accounting Terms Drop Down Axios Call
    axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTermsDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // Dropdown for the Customers
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData, "datadone===>");
        setCustomersDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/expenseaccountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData, "data=======>");
        setChartOfAccountDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // PaymentType Dropdown List
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setPaymentTypeDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err);
      });

    // ReceivingType Dropdown List
    axios
      .get(`${config.receivingBaseUrl}/receivings/receivingtypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setReceivingTypeDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err);
        //
      });

    axios
      .get(
        `${config.receivingBaseUrl}/receivings/customfieldgetall?receivingid=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // Taking the the custom fields
        setCustomFields(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/payeedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log(response.data.ResponseData, "datadone=======.");
        setPayeeOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //       const mappedReceivingItems = ReceivingItem.map((item) => {
  //         const mappedItem = {
  //           ReceivingItemID: item.ReceivingItemID,
  //           ItemId: item.ItemId,
  //           ReceivingId: item.ReceivingId,
  //           ItemName: item.Items,
  //           UnitPrice: parseFloat(item.UnitPrice),
  //           CostPrice: parseFloat(item.CostPrice),
  //           itemquantity: parseFloat(item.itemquantity),
  //           itemdiscount: parseFloat(item.itemdiscount),
  //           Ischecked: item.Ischecked,
  //           Total: parseFloat(item.Total),
  //           Module: item.Module,
  //           Itemkitid: item.ItemKitId,
  //           VariationName: item.VariationName,
  //           ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
  //           VariationQuantity: parseFloat(item.VariationQuantity),
  //           Description: item.Description,
  //           VariationId: item.VariationId,
  //           AttributeId: item.AttributeId,
  //           CategoryID: item.CategoryID,
  //           CategoryName: item.CategoryName,
  //           Itemnumber: item.Itemnumber,
  //           Allowaltdescription: item.Allowaltdescription,
  //           IsItemserialnumber: item.IsItemserialnumber,
  //         };
  //         return mappedItem;
  //       });

  //       setStateNew(mappedReceivingItems);

  //       const totalItemQuantity = mappedReceivingItems.reduce(
  //         (a, v) => (a = a + v.itemquantity),
  //         0
  //       );
  //       setTotalQuantity(totalItemQuantity);

  //       setCategoryStateNew(mappedReceivingItems);

  //       // Setting the Total amount
  //       const totalValue = SuspendedData.total;
  //       totalRef.current = parseInt(totalValue).toFixed(2);

  //       // Setting the Amount Due
  //       const dueValue = SuspendedData.AmountDue;
  //       setDueAmount(parseInt(dueValue).toFixed(2));

  //       // Setting the Comment
  //       const commentValue = SuspendedData.Comments;
  //       setComment(commentValue || "");

  //       // setting the Suppliers Id
  //       // const supplierObj = {
  //       //   suppliersvalue: SuspendedData[0].Supplier,
  //       //   suppliersName: SuspendedData[0].Name
  //       // // };
  //       // const suppliersvalue = SuspendedData[0].Supplier;
  //       // const suppliersName = SuspendedData[0].Name;
  //       // setSelectedSupplier(suppliersvalue);
  //       // console.log("suppliersvaluesuppliersvalu/e", suppliersvalue);

  //       // setSupplierName(suppliersName);
  //       // setSupplierId(supplierObj.suppliersvalue);
  //       // setSelectedOption(suppliersvalue);

  //       // setSelectedOption(suppliersName);
  //       const paymentTypeMap = {};
  //       PaymentData.forEach((payment) => {
  //         paymentTypeMap[payment.ID] = payment.Paymenttypename;
  //       });

  //       setPayments(PaymentData);
  //       setSelectedPayment(PaymentData.Paymenttypename);
  //       setPaymentTypeDropdown(PaymentData);

  //       // Reference no.
  //       setRefrenceno(SuspendedData.BillNo);

  //       // Due Date
  //       setDueDate(SuspendedData.DueDate);

  //       //Terms Id
  //       setTermsId(SuspendedData.TermsID);

  //       //Tags Id
  //       const tagIds = SuspendedData.TagIDs;
  //       // for bind the tags values
  //       if (tagIds.length > 0) {
  //         axios
  //           .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
  //             headers: {
  //               "Content-Type": "application/json;charset=UTF-8",
  //               Authorization: token,
  //             },
  //           })
  //           .then((res) => {
  //             tagsDropdownOption = res.data.ResponseData;
  //             if (tagIds.length > 0) {
  //               tagsDropdownOption.map((selectManufacturer) => {
  //                 const splitSelectedManufacturer = tagIds.split(",");
  //                 // using map() to convert array of strings to numbers
  //                 var splitSelectedManufacturernumbers =
  //                   splitSelectedManufacturer.map(function (str) {
  //                     return parseInt(str);
  //                   });
  //                 setSelectedtags(splitSelectedManufacturernumbers);
  //               });
  //             }
  //           });
  //       }

  //       // setBalanceAmount(SuspendedData.Balance);
  //       setSelectedOption(SuspendedData.Supplier);
  //       setSupplierId(SuspendedData.Supplier);
  //       // setShippingAddress(SuspendedData.ShipingAddress);
  //       setshippingAddressText(SuspendedData.ShipingAddress);
  //       setAddresssuppliers(SuspendedData.MailingAddress);
  //       setEmailsuppliers(SuspendedData.SupplierEmail);
  //       setSupplierName(SuspendedData.Name);

  //       console.log("SupplierDetail ==>", SupplierDetail);
  //       setSelectedSupplier(SupplierDetail);

  //       //Account Id
  //       setAccountId(SuspendedData.AccountID);
  //       setFileUrl(SuspendedData.Receipt);
  //       setShipToCustomer(SuspendedData.ShipToCustomer);
  //       setShipVia(SuspendedData.ShipVia);

  //       setCouponCode(SuspendedData.AddCouponCodes);
  //       setPaymentCurrency(SuspendedData.PaymentCurreny);

  //       setDiscountComment(SuspendedData.DiscountComment);
  //       // setEntireReceivingDiscount(SuspendedData.DiscountEntireSale);
  //       setCommonDiscount(SuspendedData.DiscountEntireSale);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleOptionSelect = (e, label, value) => {
  //   console.log("value", value);
  //   setSelectedReceiveDropdown(value);
  //   let eve = e.target;
  //   const dataItemId = eve.getAttribute("value");
  //   const receiveType = dataItemId;
  //   setReceivingTypeId(value);
  //   setSelect(label);
  //   setIsTransfer(label === "Transfer");
  //   setIsStoreAccountPayment(label === "Supplier Account");
  //   const selectedOption = receivingTypeDropdownOption.find(
  //     (option) => option.value == receiveType
  //   );

  //   let o = selectedOption.label;
  //   setSelectedReceiveOption(o);

  //   setIsPo(1);
  //   if (receiveType != 1) {
  //     setIsPo(0);
  //   }

  //   setIsStoreAccountPaymentFlag(0);
  //   if (receiveType === 6) {
  //     setIsStoreAccountPaymentFlag(1);
  //   }
  // };

  useEffect(() => {
    const savedData = localStorage.getItem("receivingDraft");

    const parsedData = JSON.parse(savedData);
    if (paramObject?.id === undefined) {
      if (isExpense) {
        setSelectedReceiveDropdown(7);
        setReceivingTypeId(7);
        setSelectedReceiveOption("Expense");
        // setSelectedSupplier("");
        // setSelectedOption("");

        if (savedData) {
          setSupplierId(parsedData?.ExpenseSuppliers?.value);
          setSelectedOption(parsedData?.ExpenseSuppliers);
          console.log(parsedData?.expShippingAddress, "=====>datasre");
          setSupplierQuickbookId(parsedData?.ExpenseSuppliers?.Quickbookid);
          setsuppliername(parsedData?.ExpenseSuppliers?.label);
          handleDataChange(parsedData?.ExpenseSuppliers?.value, parsedData);
          setAccountId(parsedData?.AccountId);
          setshippingAddressText(parsedData.expShippingAddress);
        }

        // const savedData = localStorage.getItem("receivingDraft");

        //   const parsedData = JSON.parse(savedData);
        //   // console.log(parsedData.ExpenseSuppliers, "localstorage");
        //   setExpensedata(parsedData?.ExpenseSuppliers);
        //   setSelectedOption(parsedData?.ExpenseSuppliers);
        // localStorage.removeItem("openpageexpenses");
        //   let x = {
        //     ...localValues,
        //     receivingDropdown: [5, "Expanse"],
        //   };
        //   setLocalValues(x);
        //   localStorage.setItem("receivingDraft", JSON.stringify(x));

        // } else {
        //   let x = {
        //     ...localValues,
        //     receivingDropdown: [5, "Purchase Order"],
        //   };
        //   setLocalValues(x);
        //   localStorage.setItem("receivingDraft", JSON.stringify(x));
        // }
      } else {
        setSelectedReceiveDropdown(1);
        setReceivingTypeId(1);
        setSelectedReceiveOption("Purchase Order");
        // setSelectedSupplier("");
        // setSelectedOption("");

        if (savedData) {
          setSupplierId(parsedData?.dropdownSuppliers?.value);
          setSelectedOption(parsedData?.dropdownSuppliers);
          console.log(parsedData?.dropdownSuppliers, "=====>datasre");
          setSupplierQuickbookId(
            parsedData?.dropdownSuppliers?.supplierquickbookIds
          );
          setsuppliername(parsedData?.dropdownSuppliers?.suppliernames);
          handleDataChange(parsedData?.dropdownSuppliers?.value, parsedData);
          setshippingAddressText(parsedData.ShippingAddress);
        }
      }
    }
  }, [isExpense]);

  console.log(selectedReceiveOption, "selectedReceiveOption");
  useEffect(() => {
    // setSelectedReceiveDropdown(1);

    if (localStorage.getItem("showTransfer")) {
      setShowTranser(true);
      localStorage.removeItem("showTransfer");
    }

    BindPageDropDown();
    // BindReceivingPageDetails();

    // if (paramObject.id > 0) {
    //   alert("Param Object ID is available");
    // }

    // if (paramObject.id > 0) {
    //   //let paramid = paramObject.id > 0 ? paramObject.id : Clone;
    //   const alertElement = (
    //     <div
    //       className="ms-3 mb-3 alert alert-danger"
    //       style={{ width: "95%" }}
    //       role="alert"
    //     >
    //       {" "}
    //       Editing Receiving RECV {paramObject.id}
    //     </div>
    //   );
    //   ReactDOM.render(alertElement, document.getElementById("alert")); // Replace 'root' with the ID of the element where you want to display the alert
    // }
  }, []);

  // const showLocationError = () => {
  //   if (!transferFromLocation) {
  //     toastError("Please select location")
  //     return
  //   }
  //   if (!transferToLocation) {
  //     toastError("Please select location")
  //     return
  //   }
  // }

  useEffect(() => {
    // if(selectedReceiveDropdown ==4 && paramObject.id > 0){
    //   BindReceivingPageDetails();
    //   console.log(1);
    // }
    // let paramid = paramObject.id > 0 ? paramObject.id : Clone;
    //localStorage.removeItem("Clone");
    let paramid = 0;
    if (paramObject.id > 0 || Clone > 0) {
      paramid = paramObject.id > 0 ? paramObject.id : Clone;
      localStorage.removeItem("Clone");
    }
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/listofsuspendrecordByidv2?id=${paramid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const SuspendedData = res.data.ResponseData.unSuspendData[0];

        console.log(SuspendedData, "data 123====>");
        const receving = res.data.ResponseData.supplierdetail[0];
        console.log(SuspendedData.TermsID, "=====ID>");
        setpayeequickbookid(receving.QuickBookId);

        if (res.data.ResponseData.supplierdetail.length > 0) {
          setSupplierQuickbookId(receving.QuickBookId);

          setsuppliername(receving.CompanyName);
        }
        setQuickbookidreceving(SuspendedData?.QuickbookId);
        setaccountrefquickbookid(SuspendedData?.accountquickbookidexpense);
        setTermsQuickbook(SuspendedData.TermsQuickBookID);
        setprevvalue(SuspendedData.ReceiveType);
        setExpensedata(receving);
        setReceivingDate(SuspendedData.ReceivingDate);
        setPayeeType(
          SuspendedData.PayeeType === 0
            ? "Supplier"
            : SuspendedData.PayeeType === 1
            ? "Customer"
            : "Employee"
        );
        // setTermsId(SuspendedData.TermsID);
        // setquickbookid()
        const PaymentData = res.data.ResponseData.paymentData;
        const ReceivingItem = res.data.ResponseData.receivingItem;
        const SupplierDetail = res.data.ResponseData.supplierdetail[0];
        const paymentAmounts = PaymentData.map((payment) =>
          parseFloat(payment.PaymentAmount)
        );
        const totalPaidAmount = paymentAmounts.reduce(
          (acc, curr) => acc + curr,
          0
        );
        // statenew
        // setStateNew(ReceivingItem);
        setSelectedReceiveOption(SuspendedData.ReceivingsType);
        setRestrictEdit(SuspendedData.RestrictEdit);
        setReceivingTypeId(SuspendedData.ReceiveType);
        setSelectedReceiveDropdown(SuspendedData.ReceiveType);
        setReceivingQuickbookId(SuspendedData.ReceiveType);
        setPaidAmount(totalPaidAmount.toFixed(2));
        setSelectedLocation(SuspendedData.LocationId);
        setSelectedTransferToLocation(SuspendedData.TransfertoLocationId);
        setIsTransfer(SuspendedData.ReceivingsType === "Transfer");
        // setSelectedLocation(SuspendedData.)
        setIsReadOnly(false);
        const mappedReceivingItems = ReceivingItem.map((item) => {
          const mappedItem = {
            ReceivingItemID: Clone > 0 ? 0 : item.ReceivingItemID,
            ItemId: item.ItemId,
            // ReceivingId: Clone > 0 ? 0 : Clone,
            ReceivingId: paramObject?.id > 0 ? paramObject?.id : 0,
            ItemName: item.Items,
            UnitPrice: parseFloat(item.UnitPrice),
            CostPrice: parseFloat(item.CostPrice),
            itemquantity: parseFloat(item.itemquantity),
            itemdiscount: parseFloat(item.itemdiscount),
            Ischecked: item.Ischecked,
            Total: parseFloat(item.Total),
            Module: item.Module,
            Itemkitid: item.ItemKitId,
            VariationName: item.VariationName,
            ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
            VariationQuantity: parseFloat(item.VariationQuantity),
            Description: item.Description,
            VariationId: item.VariationId,
            AttributeId: item.AttributeId,
            CategoryID: item.CategoryID,
            CategoryName: item.CategoryName,
            Itemnumber: item.Itemnumber,
            Allowaltdescription: item.Allowaltdescription,
            IsItemserialnumber: item.IsItemserialnumber,
            itemquickbookid: item.itemquickbookid,
            receivingitemquickbookid: item.ReceivingItemQuickbookId,
            AccountTypeName: item.AccountTypeName,
          };
          return mappedItem;
        });

        setStateNew(mappedReceivingItems);
        // statenew
        const totalItemQuantity = mappedReceivingItems.reduce(
          (a, v) => (a = a + v.itemquantity),
          0
        );
        setTotalQuantity(totalItemQuantity);

        setCategoryStateNew(mappedReceivingItems);

        // Setting the Total amount
        const totalValue = SuspendedData.total;
        totalRef.current = parseFloat(totalValue).toFixed(2);
        setPaymentAmount(totalValue);

        // Setting the Amount Due
        const dueValue = SuspendedData.AmountDue;
        setDueAmount(parseFloat(dueValue).toFixed(2));

        // Setting the Comment
        const commentValue = SuspendedData.Comments;
        setComment(commentValue || "");

        // setting the Suppliers Id
        // const supplierObj = {
        //   suppliersvalue: SuspendedData[0].Supplier,
        //   suppliersName: SuspendedData[0].Name
        // // };
        // const suppliersvalue = SuspendedData[0].Supplier;
        // const suppliersName = SuspendedData[0].Name;
        // setSelectedSupplier(suppliersvalue);
        // console.log("suppliersvaluesuppliersvalu/e", suppliersvalue);

        // setSupplierName(suppliersName);
        // setSupplierId(supplierObj.suppliersvalue);
        // setSelectedOption(suppliersvalue);

        // setSelectedOption(suppliersName);
        const paymentTypeMap = {};
        PaymentData.forEach((payment) => {
          paymentTypeMap[payment.ID] = payment.Paymenttypename;
        });

        setPayments(PaymentData);
        setSelectedPayment(PaymentData.Paymenttypename);
        setPaymentTypeDropdown(PaymentData);

        // Reference no.
        setRefrenceno(SuspendedData.BillNo);

        // Due Date
        // console.log(moment(SuspendedData.DueDate).format("YYYY-MM-DD"), "suspendedData for due")
        setDueDate(SuspendedData.DueDate);

        //Terms Id
        setTermsId(SuspendedData.TermsID);

        // setBalanceAmount(SuspendedData.Balance);
        setSelectedOption(SuspendedData.Supplier);
        setSupplierId(SuspendedData.Supplier);

        setshippingAddressText(SuspendedData.ShipingAddress);
        setAddresssuppliers(SuspendedData.MailingAddress);
        setEmailsuppliers(SuspendedData.SupplierEmail);
        setSupplierName(SuspendedData.Name);

        setSelectedSupplier(SupplierDetail);

        //Account Id
        setAccountId(SuspendedData.AccountID);
        setFileUrl(SuspendedData.Receipt);
        setShipToCustomer(SuspendedData.ShipToCustomer);
        setShipVia(SuspendedData.ShipVia);

        setCouponCode(SuspendedData.AddCouponCodes);
        setPaymentCurrency(SuspendedData.PaymentCurreny);

        setDiscountComment(SuspendedData.DiscountComment);
        // setEntireReceivingDiscount(SuspendedData.DiscountEntireSale);
        setCommonDiscount(SuspendedData.DiscountEntireSale);

        setTransferToLocation(SuspendedData.TransfertoLocationId);
        setTransferFromLocation(SuspendedData.LocationId);

        //Tags Id
        const tagIds = SuspendedData.TagIDs;
        // for bind the tags values
        if (tagIds != null && tagIds != undefined && tagIds != "") {
          axios
            .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              tagsDropdownOption = res.data.ResponseData;
              if (tagIds != "") {
                tagsDropdownOption.map((selectManufacturer) => {
                  const splitSelectedManufacturer = tagIds.split(",");
                  // using map() to convert array of strings to numbers
                  var splitSelectedManufacturernumbers =
                    splitSelectedManufacturer.map(function (str) {
                      return parseInt(str);
                    });
                  setSelectedtags(splitSelectedManufacturernumbers);
                });
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let updatedData = [];
  let updatedDatas = [];

  const handleCommonDiscountChange = (event) => {
    const newDiscountValue = Number(event.target.value);

    setCommonDiscount(newDiscountValue == 0 ? "" : newDiscountValue);

    let newTotal = 0;
    statenew.forEach((item, index) => {
      let totalPrice = 0;
      let CostPrice = item.CostPrice;
      if (isNaN(item.CostPrice)) {
        CostPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      if (!isNaN(item.CostPrice) && !isNaN(item.itemdiscount)) {
        totalPrice =
          item.CostPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      }
      totalPrice = CostPrice * item.itemquantity * (1 - itemdiscount / 100);
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });

    const totalAmount = Number(newTotal) - newDiscountValue;

    // newTotal = newTotal - Number(commonDiscount);
    totalRef.current = totalAmount;

    if (paramObject.id === undefined) {
      const x = {
        ...localValues,
        Total: totalAmount,
        CommonDiscountLS: newDiscountValue,
      };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

    let paymentTotal = totalAmount - paidAmount;
    // console.log("setDueAmount ", paymentTotal);
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    setDueAmount(paymentTotal);
  };

  const [description, setDescription] = useState("");
  // For the category description change
  const handleCategoryDescriptionChange = (index, value) => {
    //Saving data in LS
    if (paramObject.id == undefined) {
      const x = { ...localValues, Description: value };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }



    if (selectedReceiveDropdown == 5 && selectedReceiveDropdown == 7) {
      updatedData = [...categoryStatenew];
      updatedData[index] = { ...updatedData[index], Description: value };
      setCategoryStateNew(updatedData);
    } 

  
    let updatedDataState = [...statenew];
    updatedDataState[index] = {
      ...updatedDataState[index],
      Description: value,
    };
    setStateNew(updatedDataState);

   // updateTotal(updatedData);
    // setStateNew()
  };

  // For handling the category amount Change
  const handleCategoryAmountChange = (index, value) => {
    updatedData = [...categoryStatenew];
    updatedData[index] = {
      ...updatedData[index],
      CostPrice: Number(value),
      Total: Number(value),
    };

    updatedDatas = [...statenew];
    updatedDatas[index] = {
      ...updatedDatas[index],
      CostPrice: Number(value),
      Total: Number(value),
    };

console.log(updatedDatas[index],"887877");

    setCategoryStateNew(updatedData);
    if (selectedReceiveDropdown !== 5 && selectedReceiveDropdown !== 7) {
     // setTotalQuantity(newTotalQuantity);
      updateTotal(updatedDatas);
    }else {
      updateTotal(updatedData);
    }
    setStateNew(updatedDatas);
  };

  // For the Price change
  const handlePriceChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      CostPrice: value == 0 || value < 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const handleSellingChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      UnitPrice: value == 0 || value < 0 ? "" : Number(value),
    };
    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  // For handling the Quantity Change
  const handleQuantityChange = (index, value) => {
    updatedData = [...statenew];
    let itemCurrentQuantity = updatedData[index].ItemCurrentQuantity;
    // if (value === "" || Number(value) <= itemCurrentQuantity) {
    // const newValidationErrors = [...validationErrors];
    // newValidationErrors[index] = "";
    // setValidationErrors(newValidationErrors);

    updatedData[index] = {
      ...updatedData[index],
      itemquantity: value == 0 ? "" : parseInt(value),
    };
    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };
    setStateNew(updatedData);
    updateTotal(updatedData);
    // }
    // else {
    // add error message from the use state
    // const newValidationErrors = [...validationErrors];
    // newValidationErrors[index] =
    //   "Value must not exceed " + itemCurrentQuantity;
    // setValidationErrors(newValidationErrors);
    // }
  };

  const handleQtyKeyDown = (event) => {
    if (event.key === "Enter" && searchItemInputRef.current) {
      searchItemInputRef.current.focus();
      // searchItemInputRef.current.select();
    }
  };

  // For Handling the discount Change
  const handleDiscountChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      itemdiscount: value == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    setStateNew(updatedData);
    updateTotal(updatedData);
    setDiscountInputValue(value);
  };

  // Handle for the Delete Action Button
  const handleItemsDelete = (index) => {
    const newImageUrls = statenew.filter((_, i) => i !== index);
    setStateNew(newImageUrls);
    updatedData = newImageUrls;
    updateTotal(newImageUrls);
    setSelectedPayment([]);
    setPayments([]);
    // setDueAmount(0);
  };

  const handleCheckboxChange = (e, index) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      IsChecked: e.target.checked == true ? 1 : 0,
    };
    setStateNew(updatedData);
    setCheckboxes(e.target.checked == true ? 1 : 0);
  };

  const handleCategoryItemsDelete = (index) => {
    const NewCategoryList = categoryStatenew.filter((_, i) => i !== index);
    setStateNew(NewCategoryList);
    setCategoryStateNew(NewCategoryList);
    updatedData = NewCategoryList;
    updateTotal(NewCategoryList);
    setSelectedPayment([]);
    setPayments([]);
    // setDueAmount(0);
  };

  useEffect(() => {
    const paymentTotal = totalRef.current - dueAmount;
    setPaidAmount(paymentTotal > 0 ? paymentTotal.toFixed(2) : 0);
  }, [dueAmount]);

  function updateTotal(updatedData) {
     console.log(updatedData,statenew, "updatedData")

    let newTotalQuantity = 0;
    updatedData.forEach((item) => {
      newTotalQuantity += Number(item.itemquantity);
    });
    if (selectedReceiveDropdown !== 5 && selectedReceiveDropdown !== 7) {
      setTotalQuantity(newTotalQuantity);
    }

    let newTotal = 0;
    updatedData.forEach((item, index) => {
      let totalPrice = 0;
      let CostPrice = item.CostPrice;
      if (isNaN(item.CostPrice)) {
        CostPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      totalPrice = CostPrice * item.itemquantity * (1 - itemdiscount / 100);
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });

    totalRef.current = newTotal;
    let paymentTotal = newTotal - paidAmount;

    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    setDueAmount(paymentTotal);
  }

  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };
  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "SelectImage") setImageUrl(data);
        else {
          customFieldReceivingValues[type] = {
            CustomFieldLabelID: type,
            CustomFieldValue: data,
          };
          setCustomFileUrl(data);
        }
      }
    });
  };

  // const handleCheck = () => {
  //   setAddresssuppliers(addresssuppliers);
  //   setShowEdit(false);
  // };

  // const handleClose = () => {
  //   setShowEdit(false);
  // };

  const handleSelectCustomCheckBox = () => {
    setSelectCustomCheckBox(!selectCustomCheckBox);
  };
  const handleCustomFieldsValues = (event, fieldTypeName, fieldName) => {
    if (fieldTypeName === "Dropdown") {
      customFieldReceivingValues[fieldName] = {
        CustomFieldLabelID: fieldName,
        CustomFieldValue: event.label,
        CustomFieldLabel: event.selectedValue,
      };
    } else if (fieldTypeName === "Checkbox") {
      customFieldReceivingValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.checked,
        CustomFieldLabel: fieldName,
      };
    }

    // else if (fieldName === "E-Mail") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // } else if (fieldName === "Website") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // } else if (fieldName === "PhoneNumber") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // } else if (fieldName === "Date") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // }
    else {
      // console.log("fieldTypeName: ",fieldTypeName, "fieldName: ", fieldName, "value: ", event.target.name,event.target.value, "1122" )
      customFieldReceivingValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
        CustomFieldLabel: fieldName,
      };
    }
  };

  const handleItemsDetailsData = (itemDetails) => {
    // setItemsDetailsData(itemDetails.ItemId);
    setItemsDetailsData(itemDetails);
  };

  //Removing data from the local Storage
  const handleRemoveLocalData = () => {
    navigate("/receiving");
    if (isExpense) {
      // localStorage.removeItem("receivingDraft");
      // receiving
      const x = {
        ...localValues,
        expenseDropdown: [],
        ExpenseSuppliers: null,
        Description: "",
        expTags: [],
        expreferenceno: "",
        expreceivingDate: "",
        AccountId: 0,
        balanceAmount: "",
        expbottomComments: "",
        expAttachment: "",
        expShippingAddress: "",
      };

      console.log("expance clear from the localStorage");
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    } else {
      if (selectedReceiveDropdown === 5) {
        const x = {
          ...localValues,
          expenseDropdown: [],
          ExpenseSuppliers: null,
          Description: "",
          expTags: [],
          expreferenceno: "",
          expreceivingDate: "",
          AccountId: 0,
          balanceAmount: "",
          expbottomComments: "",
          expAttachment: "",
          expShippingAddress: "",
        };

        console.log("expance clear from the localStorage");
        setLocalValues(x);
        localStorage.setItem("receivingDraft", JSON.stringify(x));
      } else if (selectedReceiveDropdown === 4) {
        const x = {
          ...localValues,
          inputDropdown: [],
          receivingDropdown: null,
          dropdownSuppliers: null,
          Tags: [],
          Attachment: "",
          receivingDate: moment().format('YYYY-MM-DD'),
          referenceno: "",
          ShipToCustomer: 0,
          ShippingAddress: "",
          ShipVia: "",
          DiscountChange: 0,
          DueDate: moment().format('YYYY-MM-DD'),
          Comments: "",
          bottomComments: "",
          transferLocationChange: null,
          locationWarehouseDropdown: null,
        };
        console.log("receiving clear from the localStorage");
        setLocalValues(x);
        localStorage.setItem("receivingDraft", JSON.stringify(x));
      } else {
        const x = {
          ...localValues,
          inputDropdown: [],
          receivingDropdown: null,
          dropdownSuppliers: null,
          Tags: [],
          Attachment: "",
          receivingDate: moment().format('YYYY-MM-DD'),
          referenceno: "",
          ShipToCustomer: 0,
          ShippingAddress: "",
          ShipVia: "",
          DiscountChange: 0,
          DueDate: moment().format('YYYY-MM-DD'),
          Comments: "",
          bottomComments: "",
        };
        console.log("receiving clear from the localStorage");
        setLocalValues(x);
        localStorage.setItem("receivingDraft", JSON.stringify(x));
      }
    }
  };

  // Handle change for the Payment method
  const handelpaymentAmount = (e) => {
    setPaymentAmount(e.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, paymentAmount: e.target.value };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };
  // add receiving buttens
  const handleSuspendClick = (e, optiondata) => {
    // console.log("valueeee", e.target);
    setSelectedReceiveDropdown(optiondata.value);

    // let eve = e.target;
    // const dataItemId = eve.getAttribute("value");
    // const saleType = dataItemId;
    setReceivingTypeId(optiondata.value);
    setSelect(optiondata.label);
    setIsStoreAccountPayment(optiondata.label === "Customer Account");
    const selectedOption = receivingTypeDropdownOption.find(
      (option) => option.value == optiondata.value
    );

    let o = selectedOption.label;

    setSelectedReceiveOption(o);

    // console.log("selectedOption =>", o);
    // console.log("selectedOption ===========>", selectedOption);

    // BindInvoiceDropdown(optiondata.value);
    // setSelectDropDownValue()
  };

  const SubmitShippingAddress = (e) => {
    e.preventDefault();
    console.log(e.target[0].value, "shipping address updated");
    handleChangeAccountSalesData(e.target[0].value, "ShippingAddress");
    setShippingEditAddrerss(false);
  };

  //For persisting Data in LocalStorage

  // useEffect(() => {
  //   const savedData = localStorage.getItem("receivingDraft");
  //   console.log(savedData, "savedData")
  //   if (savedData) {
  //     const parsedData = JSON.parse(savedData);
  //     setLocalValues(parsedData);
  //     setSelectedLocation(parsedData.locationWarehouseDropdown);
  //     setSelectedTransferToLocation()
  //     // console.log(selectedReceiveDropdown, "SelectedReceiveDropdown 4545")
  //     // // console.log(parsedData?.receivingDropdown[0], "SelectedReceiveDropdown 4545")
  //     if (parsedData?.receivingDropdown != undefined) {
  //       setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
  //       setIsTransfer(parsedData?.receivingDropdown[1] === "Transfer");
  //     }
  //     let checkdropdown;
  //     if (parsedData?.receivingDropdown != undefined) {
  //       setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
  //       setSelectedReceiveOption(parsedData?.receivingDropdown[1]);
  //       setReceivingTypeId(parsedData?.receivingDropdown[0]);
  //       checkdropdown =  parsedData?.receivingDropdown[0]
  //     }
  //     setSelectedtags(parsedData.Tags)
  //     setRefrenceno(parsedData.referenceno)
  //     setshippingAddressText(parsedData.ShippingAddress)
  //     setShipToCustomer(parsedData.ShipToCustomer)
  //     setShipVia(parsedData.ShipVia)
  //     setSupplierId(parsedData?.dropdownSuppliers?.value)
  //     setSelectedOption(parsedData?.dropdownSuppliers)
  //     setTimeout(() => {
  //       setTermsId(parsedData.TermsID);
  //     }, 2000);
  //     setTimeout(() => {
  //       setAccountId(parsedData.AccountId)
  //     }, 2000);
  //     handleDataChange(parsedData?.dropdownSuppliers?.value)
  //     setStateNew((checkdropdown === 5 || checkdropdown == 7) ? parsedData?.expenseDropdown :  parsedData?.inputDropdown)
  //     setCategoryStateNew(parsedData?.expenseDropdown)
  //     setEntireReceivingDiscount(parsedData?.DiscountChange)
  //     setCommonDiscount(parsedData?.CommonDiscountLS == undefined ? 0 : parsedData?.CommonDiscountLS)
  //     setDiscountComment(parsedData?.Comments)
  //     setPaymentAmount(parsedData?.paymentAmount)
  //     setDescription(parsedData?.Description)
  //     setFileUrl(parsedData?.Attachment)
  //   }
  // }, []);
  let checkdropdown;

  useEffect(() => {
    const savedData = localStorage.getItem("receivingDraft");
    // if (isExpense) {
    //   const parsedData = JSON.parse(savedData);
    //   console.log(parsedData.ExpenseSuppliers, "localstorage");
    //   setExpensedata(parsedData?.ExpenseSuppliers);
    //   setSelectedOption(parsedData?.ExpenseSuppliers);
    // }
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      console.log(parsedData, "data321===>");
      setLocalValues(parsedData);
      setSelectedLocation(parsedData.locationWarehouseDropdown);
      // setshippingAddressText(parsedData?.address)
      setSelectedTransferToLocation(parsedData.transferLocationChange);

      if (parsedData.locationWarehouseDropdown) {
        setTransferFromLocation(true);
      }

      if (parsedData.transferLocationChange) {
        setTransferToLocation(true);
      }
      // console.log(selectedReceiveDropdown, "SelectedReceiveDropdown 4545")
      // // console.log(parsedData?.receivingDropdown[0], "SelectedReceiveDropdown 4545")
      if (parsedData?.receivingDropdown != undefined) {
        setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
        setIsTransfer(
          isExpense ? false : parsedData?.receivingDropdown[1] === "Transfer"
        );
      }

      if (paramObject?.id === undefined) {
        if (parsedData?.receivingDropdown != undefined) {
          if (isExpense) {
            setSelectedReceiveDropdown(7);
            setSelectedReceiveOption("Expense");
            setStateNew(parsedData?.expenseDropdown);
            setReceivingTypeId(7);
          } else {
            setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
            setSelectedReceiveOption(parsedData?.receivingDropdown[1]);
            setReceivingTypeId(parsedData?.receivingDropdown[0]);

            setStateNew(
              parsedData?.receivingDropdown[0] === 5
                ? parsedData?.expenseDropdown
                : parsedData?.inputDropdown
            );
          }

          // checkdropdown = parsedData?.receivingDropdown[0];
        } else {
          if (isExpense) {
            setSelectedReceiveDropdown(7);
            setSelectedReceiveOption("Expense");
            setStateNew(parsedData?.expenseDropdown);
            setReceivingTypeId(7);
          } else {
            setSelectedReceiveDropdown(1);
            setReceivingTypeId(1);
            setSelectedReceiveOption("Purchase Order");

            setStateNew(parsedData?.inputDropdown);
          }
        }
      }

      if (paramObject?.id === undefined) {
        if (isExpense) {
          setSelectedtags(parsedData.expTags);
          setReceivingDate(
            parsedData?.expreceivingDate === undefined ||
              !parsedData?.expreceivingDate
              ? today.format("YYYY-MM-DD")
              : parsedData?.expreceivingDate
          );
          setComment(parsedData?.expbottomComments);
          setFileUrl(parsedData?.expAttachment);
          setShipToCustomer(parsedData.expShipToCustomer);
          setShipVia(parsedData.expShipVia);
        } else {
          setSelectedtags(parsedData.Tags);
          setReceivingDate(
            parsedData?.receivingDate === undefined ||
              !parsedData?.receivingDate
              ? today.format("YYYY-MM-DD")
              : parsedData?.receivingDate
          );
          setComment(parsedData?.bottomComments);
          setFileUrl(parsedData?.Attachment);
          setShipToCustomer(parsedData.ShipToCustomer);
          setShipVia(parsedData.ShipVia);
        }
      }
      console.log(parsedData?.inputDropdown, "=====>data");
      console.log(statenew, "statenew99");

      if (paramObject?.id === undefined) {
        if (isExpense) {
          setSupplierId(parsedData?.ExpenseSuppliers?.value);
          setSelectedOption(parsedData?.ExpenseSuppliers);
          console.log(parsedData?.ExpenseSuppliers, "=====>datasre");
          setSupplierQuickbookId(parsedData?.ExpenseSuppliers?.Quickbookid);
          setsuppliername(parsedData?.ExpenseSuppliers?.label);
          handleDataChange(parsedData?.ExpenseSuppliers?.value, parsedData);
          setshippingAddressText(parsedData.expShippingAddress);
          setRefrenceno(parsedData.expreferenceno);
        } else {
          setSupplierId(parsedData?.dropdownSuppliers?.value);
          setSelectedOption(
            parsedData?.dropdownSuppliers !== null
              ? parsedData?.dropdownSuppliers
              : null
          );
          console.log(parsedData?.dropdownSuppliers, "=====>datasre");
          setSupplierQuickbookId(
            parsedData?.dropdownSuppliers?.supplierquickbookIds
          );
          setsuppliername(parsedData?.dropdownSuppliers?.suppliernames);
          handleDataChange(parsedData?.dropdownSuppliers?.value, parsedData);
          setshippingAddressText(parsedData.ShippingAddress);
          setRefrenceno(parsedData.referenceno);
        }
      }
      // setTimeout(() => {
      //   setTermsId(parsedData.TermsID);
      // }, 2000);
      setTimeout(() => {
        // setAccountId(parsedData.AccountId);
        setBalanceAmount(parsedData.balanceAmount);
      }, 2000);

      // setStateNew(
      //   checkdropdown === 5 || checkdropdown == 7
      //     ? parsedData?.expenseDropdown
      //     : parsedData?.inputDropdown
      // );
      setCategoryStateNew(parsedData?.expenseDropdown);
      setEntireReceivingDiscount(parsedData?.DiscountChange);
      setCommonDiscount(
        parsedData?.CommonDiscountLS == undefined
          ? 0
          : parsedData?.CommonDiscountLS
      );
      setDiscountComment(parsedData?.Comments);
      setPaymentAmount(parsedData?.paymentAmount);
      setDescription(parsedData?.Description);

      setDueDate(parsedData?.DueDate);
    }
  }, [isExpense]);

  const updateLocalValues = (statenew) => {
    const localValue1 =
      JSON.parse(localStorage.getItem("receivingDraft")) || "";
    const x = { ...localValue1, inputDropdown: statenew };
    setLocalValues(x);
    if (selectedReceiveDropdown !== 5 && selectedReceiveDropdown !== 7) {
      console.log("remove13 2");
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };

  const updateLocalValues1 = (categoryStatenew) => {
    const localValue1 =
      JSON.parse(localStorage.getItem("receivingDraft")) || "";

    const x = { ...localValue1, expenseDropdown: categoryStatenew };
    setLocalValues(x);
    if (selectedReceiveDropdown === 5 || selectedReceiveDropdown == 7) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };

  useEffect(() => {
    if (paramObject.id === undefined && !isExpense) {
      updateLocalValues(statenew);
    }
  }, [statenew]);

  useEffect(() => {
    if (paramObject.id === undefined) {
      updateLocalValues1(categoryStatenew);
    }
  }, [categoryStatenew]);

  // console.log(selectedReceiveDropdown, "SelectedReceiveDropdown 4545")
  // console.log(statenew,"statenew2263")

  //LS Total Amount

  //  let LStotalAmt;
  //  if(selectedReceiveDropdown == 5 || selectedReceiveDropdown == 7){
  //   LStotalAmt = JSON.parse(localStorage.getItem("receivingDraft"))||0;
  //    LStotalAmt = LStotalAmt?.expenseDropdown?.reduce((acc, cur) => {

  //      acc += +(cur.Total);
  //      return acc;
  //    }, 0)
  //  }
  // else{
  console.log(loading, "loadinggf==>");

  const handledatechange = (settime) => {
    setReceivingDate(settime);
    let x = {
      ...localValues,
      [isExpense ? "expreceivingDate" : "receivingDate"]: settime,
    };

    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  } 
  const handleduedatechange = (settime) => {
    let  x = { ...localValues, ['DueDate']: settime };
    setDueDate(settime);

    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

  } 

  return (
    <>
      {/* <ToastContainer /> */}
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div
          className={`${
            restirctedit == 1 && receivingTypeId == 2 ? "" : "content"
          }  container-fluid`}
        >
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h5 className="page-title">Receiving</h5> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  {isExpense === true ? (
                    <Link to="">Acccount List</Link>
                  ) : (
                    <Link to="/receiving">Receiving List</Link>
                  )}
                </li>
                {isExpense === true ? (
                  <li className="breadcrumb-item active">Expense</li>
                ) : (
                  <li className="breadcrumb-item active">Manage Receiving</li>
                )}
              </ul>
            </div>
          </div>
        </div>
        {restirctedit == 1 && receivingTypeId == 2 && (
          <div className="row align-center">
            <div
              style={{
                border: "1px solid",
                padding: "5px 10px",
                borderRadius: "5px",
                width: "fit-content",
                margin: "15px",
              }}
            >
              Payment transaction has been intiated, so you can't change the
              Receiving Type
            </div>
          </div>
        )}

        <div>
          {paramObject.id > 0 && <div id="alert"></div>}
          {/* rest of your JSX code */}
        </div>

        {/* Header */}
        <div className="row ms-2 me-2">
          <div className="col-md-8">
            {/* <div className="card" style={{ padding: "0px 5px 0 5px" }} >
              <div className="card-body" style={{ padding: "5px" }}>
                <div  style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'bold',
                      color: 'red'
                }}>
                  <div className="p-2 col-md-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    // value={receivingTypeId}
                    // defaultValue={1}
                    >
                      {selectedReceiveOption}
                    </button>

                    <ul className="dropdown-menu">
                      {receivingTypeDropdownOption.map((option, index) => (
                        // {console.log("option", option)}
                        <li key={index}>
                          <a
                            value={option.value}
                            className="dropdown-item"
                            onClick={(event) =>
                              handleOptionSelect(
                                event,
                                option.label,
                                option.value
                              )
                            }
                          >
                            {option.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                 {(restirctedit == 1 && receivingTypeId==2) &&
                  <div style={{    border: '1px solid',
                    padding: '5px 10px',
                    borderRadius: '5px'}}>
                  Payment transaction has been intiated, so you can't update the record.
                  </div>}
             
                </div>

              

              
              </div>
            </div> */}

            <div className="card col-md-12">
              <div className="card-body">
                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4 ||
                  selectedReceiveDropdown == 5 ||
                  selectedReceiveDropdown == 6 ||
                  selectedReceiveDropdown == 7) && (
                  <>
                    {toggleItemsFilterSection && (
                      <>
                        <div className="d-flex flex-row mt-2 me-2">
                          {/* Search Invoice Below */}
                          <div className="p-2 col-md-6">
                            <label className="col-form-label">Item</label>
                            <input
                              type="text"
                              id="SearchInvoice"
                              name="SearchInvoice"
                              placeholder="Search Pick List Item"
                              className="form-control form-control-sm"
                              value={searchValue}
                              onChange={handleSearchInputChange}
                            />
                            {selectedReceiveDropdown !== 6 &&
                              selectedReceiveDropdown !== 7 && (
                                <div className="d-flex flex-row mt-3">
                                  {/* <div className="col-md-12 "> */}
                                  <div className="form-check form-switch mb-3 pull-right">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="toggle-button"
                                      checked={isContentVisible}
                                      onClick={() =>
                                        setIsContentVisible(!isContentVisible)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="toggle-button"
                                    >
                                      {isContentVisible
                                        ? "Disable Pick List"
                                        : "Enable Pick List"}
                                    </label>
                                  </div>
                                  {/* </div> */}
                                </div>
                              )}
                          </div>

                          {/* Filter Category */}
                          {selectedReceiveDropdown !== 5 &&
                            selectedReceiveDropdown !== 7 && (
                              <div className="p-2 col-md-6">
                                <label className="col-form-label">
                                  Category
                                </label>
                                <Select
                                  placeholder="Filter Pick List Item"
                                  id="Filtercategory"
                                  name="Filtercategory"
                                  options={categoryDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  onChange={(event) => {
                                    handleForCategorySearch(event);
                                  }}
                                  className="custom-search-select"
                                />
                              </div>
                            )}
                        </div>
                        {/* <div className="p-2 col-md-2">
                          {(selectedReceiveDropdown == 1 ||
                            selectedReceiveDropdown == 2 ||
                            selectedReceiveDropdown == 3 ||
                            selectedReceiveDropdown == 4 ||
                            selectedReceiveDropdown == 6) && (
                            <div>
                              {selectedReceiveDropdown !== 6 && (
                                <Link
                                  type="button"
                                  className="btn btn-outline-primary w-100"
                                  data-bs-target={
                                    selectedOption != null
                                      ? "#exampleModal"
                                      : ""
                                  }
                                  onClick={(e) =>
                                    selectedOption == null
                                      ? toastError("Select Supplier First")
                                      : ""
                                  }
                                  // data-bs-target="#exampleModal"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fa fa-filter me-1"></i> Item
                                  Grid
                                </Link>
                              )}
                            </div>
                          )}
                        </div> */}
                        {/* <div className="p-2 col-md-2">
                          {selectedReceiveDropdown !== 6 && (
                            <Link
                              type="button"
                              className="btn btn-outline-dark w-100"
                              onClick={() =>
                                setToggleItemsFilterSection(
                                  !toggleItemsFilterSection
                                )
                              }
                            >
                              {!toggleItemsFilterSection ? (
                                <>
                                  <i className="fa fa-arrow-up me-1"></i>
                                  Filter
                                </>
                              ) : (
                                <>
                                  <i className="fa fa-arrow-down me-1"></i>
                                  Filter
                                </>
                              )}
                            </Link>
                          )}
                        </div> */}
                      </>
                    )}

                    <div className="m-2">
                      {selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 2 ? (
                        <>
                         
                              <div className="d-flex flex-row mt-3">
                                  {/* <div className="col-md-12 "> */}
                                  <div className="form-check form-switch mb-3 pull-right">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="toggle-button"
                                      checked={toggled}
                                      onChange={onToggle
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="toggle-button"
                                    >
                                      {toggled
                                        ?  "Accounts" : "Items"}
                                    </label>
                                  </div>
                                  {/* </div> */}
                                </div>
                        </>
                      ) : (
                        <div> </div>
                      )}
                    </div>

                    <div className="d-flex flex-wrap gap-2 mt-2 p-2">
                      <div className="d-flex w-8 ">
                        <div className="custom-fill-available">
                          {selectedReceiveDropdown !== 6 && (
                            <React.Fragment>
                              {selectedOption?.value ? (
                                <SearchableDropdown
                                  SupplierID={supplierId}
                                  callback={callback}
                                  options={options}
                                  value={selectedReceiveDropdown}
                                  selectedReceiveDropdown={
                                    selectedReceiveDropdown == 5 ||
                                    selectedReceiveDropdown == 7 ||
                                    toggled == true
                                      ? 1
                                      : 0
                                  }
                                  isExpense={isExpense}
                                  toggele={toggled}
                                  searchItemInputRef={searchItemInputRef}
                                />
                              ) : (
                                <SearchableDropdown
                                  SupplierID={supplierId}
                                  callback={callback}
                                  options={options}
                                  isExpense={isExpense}
                                  value={selectedReceiveDropdown}
                                  selectedReceiveDropdown={
                                    selectedReceiveDropdown == 5 ||
                                    selectedReceiveDropdown == 7 ||
                                    toggled == true
                                      ? 1
                                      : 0
                                  }
                                  readonly={
                                    selectedReceiveDropdown == 4
                                      ? //|| selectedReceiveDropdown == 7
                                        false
                                      : isReadOnly
                                  }
                                  toggele={toggled}
                                  searchItemInputRef={searchItemInputRef}
                                />
                              )}
                            </React.Fragment>
                          )}
                        </div>

                        {/* <div  style={{
                        display: 'flex',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        color: 'red'
                        }}> */}
                        {!isExpense && (
                          <div className="">
                            <button
                              type="button"
                              className="btn btn-sm btn-primary dropdown-toggle border-size mr-2"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {selectedReceiveOption}
                            </button>

                            <ul className="dropdown-menu col-md-3">
                              {receivingTypeDropdownOption.map(
                                (option, index) => (
                                  <li key={index} className="w-30">
                                    <a
                                      value={option.value}
                                      className="dropdown-item"
                                      onClick={(event) =>
                                        handleOptionSelect(
                                          event,
                                          option.label,
                                          option.value
                                        )
                                      }
                                    >
                                      {option.label}
                                    </a>
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        )}
                      </div>

                      {/* </div> */}
                      {/* <div className="item"> */}
                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 6) &&
                        !isExpense && (
                          <div className="col-md-2 item">
                            {selectedReceiveDropdown !== 6 && (
                              <button
                                // type="button"
                                // disabled={selectedsupplier.length==0}
                                className="btn btn-secondary  w-80"
                                data-bs-target={
                                  selectedOption != null
                                    ? "#exampleModal"
                                    : null
                                }
                                onClick={() => {
                                  // if (selectedsupplier.length == 0) {
                                  //   if(selectedReceiveDropdown !== 4){
                                  //     toastError("Select Supplier First");
                                  //   }else{
                                  //     setRunApi(true);
                                  //   }
                                  // } else {
                                  //   setRunApi(true);
                                  // }
                                  if (
                                    selectedsupplier.length === 0 &&
                                    selectedReceiveDropdown !== 4
                                  ) {
                                    toastError("Select Supplier First");
                                  } else {
                                    setRunApi(true);
                                  }
                                }}
                                data-bs-toggle="modal"
                              >
                                <i className="fa fa-filter me-1"></i> Item Grid
                              </button>
                            )}
                          </div>
                        )}
                      {/* </div> */}
                      <div className="">
                        {selectedReceiveDropdown !== 6 && (
                          <Link
                            to={isExpense ? "/Expense" : "/manage-receiving"}
                            type="button"
                            className="btn  btn-secondary  w-20"
                            onClick={() =>
                              setToggleItemsFilterSection(
                                !toggleItemsFilterSection
                              )
                            }
                          >
                            {!toggleItemsFilterSection ? (
                              <>
                                <i className="fa fa-arrow-up me-1"></i>
                                Filter
                              </>
                            ) : (
                              <>
                                <i className="fa fa-arrow-down me-1"></i>
                                Filter
                              </>
                            )}
                          </Link>
                        )}
                      </div>
                    </div>

                    {/* {selectedReceiveDropdown !== 6 &&
                      selectedReceiveDropdown !== 7 && (
                        <div className="d-flex flex-row mt-3">
                          <div className="col-md-12 ">
                            <div className="form-check form-switch mb-3 pull-right">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="toggle-button"
                                checked={isContentVisible}
                                onClick={() =>
                                  setIsContentVisible(!isContentVisible)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="toggle-button"
                              >
                                {isContentVisible
                                  ? "Disable Pick List"
                                  : "Enable Pick List"}
                              </label>
                            </div>
                          </div>
                        </div>
                      )} */}
                  </>
                )}

                {/* For Item and Item Kits */}
                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4 ||
                  selectedReceiveDropdown == 6) && (
                  <div className="row">
                    <div className="col-md-12">
                      {/* <div> */}
                      <div className="table-responsive">
                        <table
                          className="table custom-table"
                          // style={{ width: "1024px" }}
                        >
                          <thead>
                            <tr>
                              {selectedReceiveDropdown !== 6 &&
                                (showRowInternalDetails ? (
                                  <th
                                    style={{ width: "50px" }}
                                    onClick={(e) => handleShowDetails(e)}
                                  >
                                    <i class="fa fa-minus"></i> No.
                                  </th>
                                ) : (
                                  <th
                                    style={{ width: "50px" }}
                                    onClick={(e) => handleShowDetails(e)}
                                  >
                                    <i class="fa fa-plus"></i> No.
                                  </th>
                                ))}
                              {selectedReceiveDropdown === 6 && (
                                <th style={{ width: "50px" }}>Item Name</th>
                              )}
                              {/* {selectedReceiveDropdown !== 6 && (
                                  <th>Item Name</th>
                                )} */}
                              {selectedReceiveDropdown === 6 && (
                                <th style={{ width: "250px" }}>
                                  Payment Amount
                                </th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "150px" }}>Cost Price</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "120px" }}>Qty</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "120px" }}>Disc.(%)</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "120px" }}> Total</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th
                                  style={{ width: "50px" }}
                                  className="text-center"
                                ></th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th
                                  style={{ width: "50px" }}
                                  className="text-center"
                                >
                                  {isContentVisible && (
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="CheckBox"
                                      id="CheckBox"
                                      onChange={(e) => {
                                        const checkboxes =
                                          document.querySelectorAll(
                                            'tbody input[type="checkbox"]'
                                          );
                                        checkboxes.forEach((checkbox) => {
                                          checkbox.checked = e.target.checked;
                                        });
                                      }}
                                    />
                                  )}
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {selectedReceiveDropdown === 6 && (
                              <tr>
                                <td>
                                  {/* <Link
                                    type="button"
                                    data-bs-target="#StoreAccountPaymentModal"
                                    data-bs-toggle="modal"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  > */}
                                  Supplier Account
                                  {/* </Link> */}
                                </td>

                                <StoreAccountPaymentModal />
                                <td>
                                  <input
                                    id="paymentamount"
                                    name="paymentamount"
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={paymentAmount}
                                    onChange={(e) => handelpaymentAmount(e)}
                                  />
                                </td>
                              </tr>
                            )}

                            {statenew
                              ?.filter(
                                (item) =>
                                  // item.Module !== "Accounts" &&
                                  item.ItemName?.toLowerCase().includes(
                                    searchValue?.toLowerCase()
                                  ) &&
                                  (selectedCategoryForSearch
                                    ? item.CategoryID ===
                                      selectedCategoryForSearch
                                    : true)
                              )
                              .map((item, index) => {
                                const filteredIndex = statenew.indexOf(item);
                                console.log(item.Description, "3275");
                                return (
                                  <>
                                    <tr
                                      className={
                                        "gridrow-" +
                                        (filteredIndex % 2 ? "even" : "odd")
                                      }
                                    >
                                      {(selectedReceiveDropdown == 1 ||
                                        selectedReceiveDropdown == 2 ||
                                        selectedReceiveDropdown == 3 ||
                                        selectedReceiveDropdown == 4 ||
                                        selectedReceiveDropdown == 5 ||
                                        selectedReceiveDropdown == 7) && (
                                        <>
                                          <td rowSpan={2}>
                                            {filteredIndex + 1}
                                          </td>
                                          {item.Module !== "Accounts" ? (
                                            <td colSpan={7} className="p-1">
                                              <Link
                                                type="button"
                                                onClick={(e) =>
                                                  handleItemsDetailsData(item)
                                                }
                                                data-bs-target="#ItemsDetailsModal"
                                                data-bs-toggle="modal"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <p className="word-break-data" style={{fontSize: '14px', fontWeight:500}}>
                                                  {item.VariationName != "" &&
                                                  item.VariationName != null
                                                    ? item.VariationName
                                                    : item.ItemName}
                                                </p>
                                              </Link>
                                            </td>
                                          ) : (
                                            <td></td>
                                          )}
                                        </>
                                      )}
                                    </tr>
                                    <tr
                                      key={item.modifyid}
                                      className={
                                        "gridrow-" +
                                        (filteredIndex % 2 ? "even" : "odd")
                                      }
                                    >
                                      {selectedReceiveDropdown !== 6 && (
                                        <>
                                          {/* <td>{filteredIndex + 1}</td> */}
                                          {/* <td>
                                              <Link
                                                type="button"
                                                onClick={(e) =>
                                                  handleItemsDetailsData(item)
                                                }
                                                data-bs-target="#ItemsDetailsModal"
                                                data-bs-toggle="modal"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <p className="word-break-data">
                                                  {item.VariationName != "" ? item.VariationName : item.ItemName}
                                                </p>
                                              </Link>
                                            </td> */}
                                        </>
                                      )}

                                      {selectedReceiveDropdown !== 6 &&
                                        (item.Module !== "Accounts" ? (
                                          <td className="table-control-td">
                                            <span className="table-control-label">
                                              Cost Price
                                            </span>
                                            <input
                                              type="number"
                                              value={item.CostPrice ?? 0} // Ensure a default value for controlled input
                                              className="form-control form-control-sm"
                                              onChange={(e) => {
                                                const value =
                                                  parseFloat(e.target.value) ||
                                                  0; // Ensure the value is numeric
                                                if (value >= 0) {
                                                  handlePriceChange(
                                                    filteredIndex,
                                                    value
                                                  );
                                                }
                                              }}
                                            />
                                          </td>
                                        ) : (
                                          <td className="table-control-td">  
                                           <span className="table-control-label">
                                          Category :
                                        </span>
                                        <p> {item.ItemName} </p></td>
                                        ))}

                                      {selectedReceiveDropdown !== 6 && (
                                        item.Module !== "Accounts" ?
                                        (<td className="table-control-td">
                                          <span className="table-control-lable">
                                            Qty
                                          </span>
                                          <input
                                            type="number"
                                            ref={
                                              index === 0 ? qtyInputRef : null
                                            }
                                            value={item.itemquantity}
                                            // min={1}
                                            // max={item.ItemCurrentQuantity}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (value >= 0) {
                                                handleQuantityChange(
                                                  filteredIndex,
                                                  e.target.value
                                                );
                                              }
                                            }}
                                            onKeyDown={handleQtyKeyDown}
                                          />

                                          {/* {validationErrors[filteredIndex] && (
                                            <p className="text-danger">
                                              {validationErrors[filteredIndex]}
                                            </p>
                                          )} */}
                                        </td> ) : ( <td>
                                          <span className="table-control-label">
                                          Description
                                            </span>
                                        <input
                                          type="text"
                                          value={item.Description == null ? "": item.Description}
                                          className="form-control"
                                          onChange={(e) =>
                                            handleCategoryDescriptionChange(
                                              filteredIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>)
                                      )}

                                      {selectedReceiveDropdown !== 6 && (
                                        item.Module !== "Accounts" ? (<td className="table-control-td">
                                          <span className="table-control-lable">
                                            Discount
                                          </span>
                                          <input
                                            type="number"
                                            value={item.itemdiscount}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (value >= 0) {
                                                handleDiscountChange(
                                                  filteredIndex,
                                                  e.target.value
                                                );
                                              }
                                            }}
                                          />
                                        </td> ) : ( <td>
                                          <span className="table-control-label">
                                          Amount
                                            </span>
                                        <input
                                          type="number"
                                          value={item.CostPrice}
                                          className="form-control"
                                          onChange={(e) =>
                                            handleCategoryAmountChange(
                                              filteredIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>)
                                      )}
                                      {selectedReceiveDropdown !== 6 && (
                                        item.Module !== "Accounts" ? (
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Total
                                          </span>
                                          <input
                                            type="number"
                                            // value={calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)}
                                            value={item.Total}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (value >= 0) {
                                                handleTotalChange(
                                                  filteredIndex,
                                                  e.target.value
                                                );
                                              }
                                            }}
                                          />
                                        </td>) : (<td></td>)
                                        // <td>
                                        //   {calculateTotal(
                                        //     item.UnitPrice,
                                        //     item.itemquantity,
                                        //     item.itemdiscount
                                        //   )}
                                        // </td>
                                      )}
                                      {/* <td></td> */}

                                      {selectedReceiveDropdown !== 6 && (
                                        <td>
                                          <div
                                            // className="confirm-text"
                                            // to={
                                            //   isExpense
                                            //     ? paramObject.id > 0 ? `/manage-receiving/${paramObject.id}?expense=true`: "/manage-receiving?expense=true"
                                            //     : paramObject.id > 0 ? `/manage-receiving/${paramObject.id}` : "/manage-receiving"
                                            // }
                                            title="Delete"
                                            style={{
                                              fontSize: "12px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleItemsDelete(index)
                                            }
                                          >
                                            <i
                                              className="fa fa-trash text-red fa-2x"
                                              data-bs-toggle="tooltip"
                                              title="Delete"
                                            ></i>
                                          </div>
                                        </td>
                                      )}
                                      {selectedReceiveDropdown !== 6 && (
                                        <td>
                                          {isContentVisible && (
                                            <input
                                              className="form-check-input"
                                              // style={{
                                              //   width: "1.5em",
                                              //   height: "1.5em",
                                              // }}
                                              type="checkbox"
                                              name={`CheckBox${index}`}
                                              id={`CheckBox${index}`}
                                              // checked={item.Ischecked === 1}
                                              defaultChecked={item.Ischecked}
                                              // checked={checkboxes[index] || false}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, index)
                                              }
                                            />
                                          )}
                                        </td>
                                      )}
                                    </tr>
                                    {(selectedReceiveDropdown == 1 ||
                                      selectedReceiveDropdown == 2 ||
                                      selectedReceiveDropdown == 3 ||
                                      selectedReceiveDropdown == 4 ||
                                      selectedReceiveDropdown == 5 ||
                                      selectedReceiveDropdown == 7) && (
                                      <tr
                                        className={
                                          "gridrow-" +
                                          (filteredIndex % 2 ? "even" : "odd")
                                        }
                                      >
                                        {showRowInternalDetails && (
                                          <td colSpan={8} className="p-0">
                                            <div className="bottom-table">
                                              <table className="custom-table">
                                                <tbody>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Category:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item?.CategoryName}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Stock:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item?.ItemCurrentQuantity ===
                                                        undefined ||
                                                      item?.ItemCurrentQuantity ===
                                                        null ||
                                                      item?.ItemCurrentQuantity ===
                                                        NaN
                                                        ? 0
                                                        : Number(item?.ItemCurrentQuantity).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      UPC/EAN/ISBN:
                                                    </td>
                                                    <td className="custom-cell">
                                                      {item?.Itemnumber ==
                                                      undefined
                                                        ? "-"
                                                        : item?.Itemnumber}
                                                    </td>
                                                  </tr>
                                                  <tr className="custom-row">
                                                    <td className="custom-cell"></td>
                                                    <td className="custom-cell">
                                                      Selling Price:
                                                    </td>
                                                    <td className="custom-cell">
                                                      <input
                                                        type="number"
                                                        value={item?.UnitPrice}
                                                        onChange={(e) =>
                                                          handleSellingChange(
                                                            filteredIndex,
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control custom-input"
                                                        readOnly
                                                      />
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </td>
                                        )}
                                      </tr>
                                    )}
                                  </>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                )}

                {(selectedReceiveDropdown == 7 ||
                  selectedReceiveDropdown == 5) && (
                  <div className="col-md-12 mt-2">
                    <div>
                      <div className="table-responsive">
                        <table className="table table-striped custom-table">
                          <thead>
                            <tr>
                              <th>No.</th>
                              <th>Category</th>
                              <th>Description</th>
                              <th>Amount</th>
                              <th>Delete</th>
                              {isContentVisible &&
                                selectedReceiveDropdown !== 7 && (
                                  <th>
                                    <input
                                      className="form-check-input"
                                      // style={{ width: "1.5em", height: "1.5em" }}
                                      type="checkbox"
                                      name="CheckAll"
                                      id="CheckAll"
                                      onChange={(e) => {
                                        const checkboxes =
                                          document.querySelectorAll(
                                            'tbody input[type="checkbox"]'
                                          );
                                        checkboxes.forEach((checkbox) => {
                                          checkbox.checked = e.target.checked;
                                        });
                                      }}
                                    />
                                  </th>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {categoryStatenew
                              ?.filter(
                                (item) =>
                                  item.Module == "Accounts" &&
                                  item.ItemName?.toLowerCase().includes(
                                    searchValue?.toLowerCase()
                                  )
                              )
                              .map((item, index) => {
                                const filteredIndex =
                                  categoryStatenew.indexOf(item);
                                return (
                                  <>
                                    <tr key={item.modifyid}>
                                      <td>{filteredIndex + 1}</td>
                                      <td>{item.ItemName}</td>
                                      <td>
                                        <input
                                          type="text"
                                          value={item.Description}
                                          className="form-control"
                                          onChange={(e) =>
                                            handleCategoryDescriptionChange(
                                              filteredIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          value={item.CostPrice}
                                          className="form-control"
                                          onChange={(e) =>
                                            handleCategoryAmountChange(
                                              filteredIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      {/* <td></td> */}
                                      <td>
                                        <div
                                          // className="confirm-text"
                                          // to={
                                          //   isExpense
                                          //     ? "/manage-receiving?expense=true"
                                          //     : "/manage-receiving"
                                          // }
                                          title="Delete"
                                          style={{
                                            fontSize: "12px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleCategoryItemsDelete(index)
                                          }
                                        >
                                          <i
                                            className="fa fa-trash text-red fa-2x"
                                            data-bs-toggle="tooltip"
                                            title="Delete"
                                          ></i>
                                        </div>
                                      </td>
                                      {/* <td>
                                        {isContentVisible && selectedReceiveDropdown !== 7 && (
                                          <input
                                            type="text"
                                            value={item.Description}
                                            className="form-control" 
                                            onChange={(e) =>
                                              handleCategoryDescriptionChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        )}
                                        </td> */}
                                      {/* <td>
                                          <input
                                            type="number"
                                            value={item.CostPrice}
                                            className="form-control"
                                            onChange={(e) =>
                                              handleCategoryAmountChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td> */}
                                      {/* <td></td> */}
                                      {/* <td>
                                          <Link
                                            className="confirm-text"
                                            to="#"
                                            title="Delete"
                                            style={{ fontSize: "12px" }}
                                            onClick={() =>
                                              handleCategoryItemsDelete(index)
                                            }
                                          >
                                            <i
                                              className="fa fa-trash text-red fa-2x"
                                              data-bs-toggle="tooltip"
                                              title="Delete"
                                            ></i>
                                          </Link>
                                        </td> */}
                                      <td>
                                        {isContentVisible &&
                                          selectedReceiveDropdown !== 7 && (
                                            <input
                                              className="form-check-input form-control"
                                              // style={{
                                              //   width: "1.5em",
                                              //   height: "1.5em",
                                              // }}
                                              type="checkbox"
                                              name={`CheckBox${index}`}
                                              id={`CheckBox${index}`}
                                              defaultChecked={item.Ischecked}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, index)
                                              }
                                            />
                                          )}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {/* </div> */}
              </div>
            </div>

            {/* <div className="card">
              <div className="card-body">
                <div className="p-2">
                  Receipt:
                  <input
                    type="file"
                    className="form-control"
                    id="Receipt"
                    name="Receipt"
                    onChange={handleFileChange}
                  />
                  {FileUrl == "" ? (
                    ""
                  ) : (
                    <Link to={FileUrl} target="_blank">
                      Attachment Link
                    </Link>
                  )}
                </div>
              </div>
            </div> */}
          </div>
          {/* Right Side Content */}
          <div className="col-md-4 scroll-position">
            <div className="card">
              <div className="card-body ">
                <div className="d-flex justify-content-between mb-2 pl-2 pr-2">
                  <div className="card-Supplier-Customer">
                    {isExpense
                      ? "Payee"
                      : selectedReceiveDropdown === 4
                      ? "Transfer"
                      : "Supplier"}
                  </div>
                  <div className="d-flex">
                      <button
                        className="btn btn-sm btn-clear-Data mr-2"
                        type="button"
                        data-bs-target="#HistoryModel"
                        data-bs-toggle="modal"
                        onClick={()=> setShowHistoryList(true)}
                      >
                       History
                      </button>
                    {paramObject?.id == undefined && (
                      <button
                        className="btn btn-sm btn-clear-Data mr-2"
                        onClick={handleRemoveLocalData}
                      >
                        Clear Data
                      </button>
                    )}
                    <Link
                      to="/receiving"
                      className="btn btn-sm btn-clear-Data mr-2"
                    >
                      Back
                    </Link>
                    <div className="btn-group btn-group-sm pull-right">
                      {checkUserPermission(PERMISSION_TRANSFER) ||
                      checkUserPermission(PERMISSION_INCOMING) ||
                      // checkUserPermission(PERMISSION_PURCHASE) ||
                      checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                        //|| checkUserPermission(PERMISSION_BATCHRECEIVING) ||
                        //  checkUserPermission(PERMISSION_CUSTOMFIELD)
                        <button
                          type="button"
                          className="btn me-1 btn-clear-Data"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          // style={{fontSize:"xx-small"}}
                        >
                          <i
                            class="fa fa-circle"
                            style={{
                              color: "var(--primary-color-800) !important",
                              fontSize: "6px",
                            }}
                          ></i>{" "}
                          <i
                            class="fa fa-circle"
                            style={{
                              color: "var(--primary-color-800) !important",
                              fontSize: "6px",
                            }}
                          ></i>{" "}
                          <i
                            class="fa fa-circle"
                            style={{
                              color: "var(--primary-color-800) !important",
                              fontSize: "6px",
                            }}
                          ></i>
                        </button>
                      ) : (
                        " "
                      )}
                      <ul className="dropdown-menu">
                        {/* <li>
                                <Link
                                  to="/suspended-receiving"
                                  title="Suspended receiving"
                                  className="dropdown-item"
                                >
                                  <i className="far fa-file fs-6 me-1"></i> Suspended
                                  Receivings And Purchase orders
                                </Link>
                              </li> */}

                        {checkUserPermission(PERMISSION_TRANSFER) ? (
                          <li>
                            <Link
                              to="/transfer-request/1"
                              title="Suspended receiving"
                              className="dropdown-item"
                            >
                              {/* <FontAwesomeIcon icon="fa-solid fa-shuffle" /> */}
                              Transfer Request
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}

                        {checkUserPermission(PERMISSION_INCOMING) ? (
                          <li>
                            <Link
                              to="/suspended-receiving/0"
                              title="Suspended receiving"
                              className="dropdown-item"
                            >
                              {/* <i className="far fa-file fs-6 me-1"></i> */}
                              Incoming Transfers
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}

                        {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 1365-
                        {checkUserPermission(PERMISSION_PURCHASE) ? (
                          <li>
                            <Link
                              to="/create-purchase-orders"
                              title="Create Purchase Order"
                              className="dropdown-item"
                            >
                              Create Purchase Orders
                            </Link>
                          </li>
                        ) : (
                          ""
                        )} */}

                        {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                          <li>
                            <Link
                              // type="button"
                              className="dropdown-item"
                              data-bs-target="#LookupReceiptModal"
                              data-bs-toggle="modal"
                            >
                              {/* <i className="far fa-file fs-6 me-1"></i> */}
                              Lookup Receipt
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                        {/* <LookupReceiptModal /> */}

                        {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                          <li>
                            <Link
                              to="/receiving-receipt"
                              title="Suspended receiving"
                              className="dropdown-item"
                            >
                              {/* <i className="far fa-file fs-6 me-1"></i> */}
                              Show Last Receiving
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}

                        {/* {checkUserPermission(PERMISSION_BATCHRECEIVING) ? (
                          <li>
                            <Link
                              to="/batch-receiving"
                              title="Suspended receiving"
                              className="dropdown-item"
                            >
                              {/* <i className="fas fa-shopping-bag fs-6 me-1"></i> */}
                        {/* Batch Receiving
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}

                        {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                          <li>
                            <Link
                              to={"/receiving-custom-field"}
                              className="dropdown-item"
                            >
                              {/* <i className="fas fa-wrench fs-6 me-1"></i> */}
                        {/* Custom Field Configuration
                            </Link>{" "}
                          </li>
                        ) : (
                          ""
                        )} */}
                      </ul>
                    </div>
                  </div>
                </div>
                <hr />

                {/* hide suspend and cancel  */}
                {/* <div className="">
                  {(selectedReceiveDropdown == 1 ||
                    selectedReceiveDropdown == 2 ||
                    selectedReceiveDropdown == 3 ||
                    selectedReceiveDropdown == 4) && (
                    <div className="row">
                      {statenew && statenew.length > 0 ? (
                        <>
                          <div
                            className="col-md-4"
                            // onClick={handleSuspend}
                          >
                            <button
                                className="btn btn-sm btn-outline-primary ms-1 mb-2"
                                data-bs-target="#SuspendedModal"
                                data-bs-toggle="modal"
                              // onClick={() => {
                              //   // handleSuspendedPopup();
                              //   handleCompleteSale("suspend");
                              // }}
                              >
                                <div className="d-inline-flex align-items-center">
                                  <i class="fas fa-solid fa-pause me-1"></i>
                                  Suspend
                                </div>
                              </button>
                          </div>
                          <div className="col-md-4">
                              <button
                                className="btn  btn-sm btn-outline-primary ms-1 mb-2"
                                data-bs-toggle="modal"
                                data-bs-target="#CancelModal"
                                onClick={() => handleCancelPopup()}
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    src={Closed}
                                    alt="img"
                                    style={{
                                      marginRight: "0.5rem",
                                      width: "0.9rem",
                                      height: "0.9rem",
                                    }}
                                  />
                                  Cancel
                                </div>
                              </button>
                            </div>
                        </>
                      ) : null}
                    </div>
                  )}
                </div> */}
                {/* !isExpense set on transfer */}
                {!isTransfer ? (
                  <div>
                    {!selectedOption ? (
                      <div className="input-group flex-nowrap ">
                        <span
                          className="input-group-text border-size-input"
                          id="addon-wrapping"
                        >
                          <Link to="/manage-suppliers">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-person-plus"
                              viewBox="0 0 16 16"
                            >
                              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                              <path
                                fillRule="evenodd"
                                d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                              />
                            </svg>
                          </Link>
                        </span>

                        <Select
                          className=" w-100"
                          name="supplierid"
                          id="supplierid"
                          placeholder={
                            selectedReceiveDropdown == 7
                              ? "Select Payee"
                              : "Select a Supplier"
                          }
                          options={
                            selectedReceiveDropdown == 7
                              ? payeeFilteredOptions
                              : options
                          }
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE}
                          value={selectedOption}
                          onChange={(e) => {
                            setSelectedOption(e);
                            setPayeeTypes(e?.type);
                            // setshippingAddressText(e?.address)
                            handleSelectChange(e);
                            //console.log("event::>", e);
                          }}
                        />
                      </div>
                    ) : (
                      <>
                        {/* <ReceivingCard
                          value={selectedOption}
                          onCancel={handleCancelClick}
                        /> */}
                        <ReceivingCard
                          // data={selectedsupplier}
                          data={
                            isExpense
                              ? Expensedata
                              : {
                                  ...selectedsupplier,
                                  inputBilling: addresssuppliers,
                                  PayeeType: 0,
                                }
                          }
                          onCancel={handleCancelClick}
                          visible={selectedsupplier?.Id === supplierId}
                          callback={callbackMailingAddress}
                        />
                      </>
                    )}

                    {/* Mailing Address: */}
                    {/* {selectedReceiveDropdown !== 6 && (
                      <div className="mb-2 col-md-12 mt-2">
                        Mailing Address:
                        {
                          showEdit ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <textarea
                              id="MailingAddress"
                              name="MailingAddress"
                              placeholder="Mailing Address"
                              onChange={(event) =>
                                handleChangeAccountSalesData(
                                  event,
                                  "MailingAddress"
                                )
                              }
                              value={addresssuppliers}
                              className="form-control h-100"
                            ></textarea>
                            <AiOutlineCheck
                              style={{ width: "40px" }}
                              onClick={handleCheck}
                            />
                            <GrFormClose
                              style={{ width: "40px", fontSize: "20px" }}
                              onClick={handleClose}
                            />
                          </div>
                        ) : (
                          <div>
                            <p>
                              {addresssuppliers}
                              <i
                                onClick={() => setShowEdit(true)}
                                className="fa fa-edit text-warning fa-1x"
                                style={{ marginLeft: "10px" }}
                              ></i>
                            </p>
                          </div>
                        )
                        }
                      </div>
                    )} */}

                    {/* Shipping Address: */}

                    {selectedReceiveDropdown !== 6 && (
                      // <div className="mb-2 col-md-12">
                      //   Shipping Address:
                      //   <div>
                      //     {shippingEditAddrerss ? (
                      //       <form
                      //         onSubmit={SubmitShippingAddress}
                      //         className="d-flex"
                      //         style={{
                      //           display: "flex",
                      //           alignItems: "center",
                      //           border: "1px solid lightgray",
                      //           borderRadius: "5px",
                      //           width: "auto",
                      //         }}
                      //       >
                      //         <input
                      //           id="ShippingAddress"
                      //           name="ShippingAddress"
                      //           placeholder="Shipping Address"
                      //           className="form-control h-100"
                      //           // value={shippingAddress}
                      //           // onChange={(event) => {
                      //           //   handleChangeAccountSalesData(
                      //           //     event,
                      //           //     "ShippingAddress"
                      //           //   );
                      //           // }}
                      //           defaultValue={shippingAddressText}
                      //           style={{ border: "none" }}
                      //         ></input>
                      //         <button
                      //           className="btn btn-outline-primary btn-sm m-1"
                      //           type="submit"
                      //         >
                      //           <i
                      //             className="fa fa-check"
                      //             aria-hidden="true"
                      //           ></i>
                      //         </button>
                      //         <div
                      //           className="btn btn-outline-danger btn-sm m-1"
                      //           onClick={() => setShippingEditAddrerss(false)}
                      //         >
                      //           <i
                      //             className="fa fa-times"
                      //             aria-hidden="true"
                      //           ></i>
                      //         </div>
                      //       </form>
                      //     ) : shippingAddressText == "" ? (
                      //       <div>
                      //         <i
                      //           class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                      //           aria-hidden="true"
                      //         ></i>
                      //         <></>
                      //         <i
                      //           className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                      //           style={{ fontSize: "16px", cursor: "pointer" }}
                      //           onClick={() => setShippingEditAddrerss(true)}
                      //         ></i>
                      //       </div>
                      //     ) : (
                      //       <>
                      //         <i
                      //           class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                      //           aria-hidden="true"
                      //         ></i>
                      //         {shippingAddressText}
                      //         <i
                      //           className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                      //           style={{ fontSize: "16px", cursor: "pointer" }}
                      //           onClick={() => setShippingEditAddrerss(true)}
                      //         ></i>
                      //       </>
                      //     )}
                      //   </div>
                      // </div>

                      <div className="accordion-item">
                        <hr />
                        <div
                          className="accordion-header"
                          style={{ cursor: "pointer" }}
                          onClick={toggleAccordion}
                        >
                          <button
                            class="accordion-button dropdown-toggle"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Shipping Address
                          </button>
                        </div>

                        {isAccordionOpen && (
                          <div className="accordion">
                            <div className="mb-2 col-md-12">
                              <div>
                                {shippingEditAddrerss ? (
                                  <form
                                    onSubmit={SubmitShippingAddress}
                                    className="d-flex"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      border: "1px solid lightgray",
                                      borderRadius: "5px",
                                      width: "auto",
                                    }}
                                  >
                                    <input
                                      id="ShippingAddress"
                                      name="ShippingAddress"
                                      placeholder="Shipping Address"
                                      className="form-control h-100"
                                      // value={shippingAddress}
                                      // onChange={(event) => {
                                      //   handleChangeAccountSalesData(
                                      //     event,
                                      //     "ShippingAddress"
                                      //   );
                                      // }}
                                      defaultValue={shippingAddressText}
                                      // onChange={(e)=>setShippingAddress(e.target.value)}
                                      style={{ border: "none" }}
                                    ></input>
                                    <button
                                      className="btn-outline-success"
                                      // onClick={() =>
                                      //   setShippingEditAddrerss(false)
                                      // }
                                      type="submit"
                                    >
                                      <i
                                        className="fa fa-check"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <div
                                      className="btn-outline-danger"
                                      onClick={() =>
                                        setShippingEditAddrerss(false)
                                      }
                                    >
                                      <i
                                        className="fa fa-times"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </form>
                                ) : shippingAddressText == "" ? (
                                  <div>
                                    <i
                                      className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                                      aria-hidden="true"
                                    ></i>
                                    <>{shippingAddressText}</>
                                    <i
                                      className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                      style={{
                                        fontSize: "16px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setShippingEditAddrerss(true)
                                      }
                                    ></i>
                                  </div>
                                ) : (
                                  <>
                                    <i
                                      class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                      aria-hidden="true"
                                    ></i>
                                    {shippingAddressText}
                                    <i
                                      className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                      style={{
                                        fontSize: "16px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setShippingEditAddrerss(true)
                                      }
                                    ></i>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-md-12 mt-2">
                      <div className="input-group">
                        <div className="input-group flex-nowrap ">
                          <span
                            className="input-group-text"
                            id="addon-wrapping"
                          >
                            <Link to="/manage-locations">
                              <i class="fas fa-solid fa-plus"></i>
                            </Link>
                          </span>
                          <Select
                            className="w-100"
                            options={locationDropdownOption}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            // onChange={handleLocationChange}
                            onChange={(e) => handleLocationChange(e)}
                            value={locationDropdownOption.find(
                              (option) => option?.value == selectedLocation
                            )}
                            placeholder="Transfer From Location"
                          />
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <div className="input-group">
                          <span
                            className="input-group-text"
                            id="addon-wrapping"
                          >
                            <Link to="/manage-locations">
                              <i class="fas fa-solid fa-plus"></i>
                            </Link>
                          </span>
                          <Select
                            className="w-100"
                            options={locationDropdownOption}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            // value={selectedTransferToLocation}
                            value={locationDropdownOption.find(
                              (option) =>
                                option?.value == selectedTransferToLocation
                            )}
                            // onChange={handleTransferToLocationChange}
                            onChange={(e) => handleTransferToLocationChange(e)}
                            placeholder="Transfer To Location"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="card" style={{ padding: "0px 5px 0 5px" }}>
              <div className="card-body" style={{ padding: "5px" }}>
                {/* <div  style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'bold',
                      color: 'red'
                }}>
                  <div className="p-2 col-md-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                   
                    >
                      {selectedReceiveOption}
                    </button>

                    <ul className="dropdown-menu">
                      {receivingTypeDropdownOption.map((option, index) => (
                        
                        <li key={index}>
                          <a
                            value={option.value}
                            className="dropdown-item"
                            onClick={(event) =>
                              handleOptionSelect(
                                event,
                                option.label,
                                option.value
                              )
                            }
                          >
                            {option.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                 {(restirctedit == 1 && receivingTypeId==2) &&
                  <div style={{    border: '1px solid',
                    padding: '5px 10px',
                    borderRadius: '5px'}}>
                  Payment transaction has been intiated, so you can't update the record.
                  </div>}
                 
                </div> */}
                {selectedReceiveDropdown == 7 && (
                  <>
                    {/* AccountId */}
                    <div className="p-2 col-md-12">
                      <label className="col-form-label">Account:</label>
                      <Select
                        id="AccountId"
                        name="AccountId"
                        onChange={(event) => {
                          console.log(event, "dataofevenet");
                          handleChangeAccountSalesData(event, "AccountId");
                          setBalanceAmount(event?.amount);
                          setaccountrefquickbookid(event?.quickbookid);
                        }}
                        options={accountTypeDropdownOption}
                        value={accountTypeDropdownOption?.find(
                          (option) => option?.value == accountId
                        )}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="custom-search-select"
                        required={true}
                      />
                    </div>
                    {/* {balanceAmount && (
                          <div className="p-2 col-md-12">
                            <label className="col-form-label">Account:</label>
                            <Select
                              id="AccountId"
                              name="AccountId"
                              onChange={(event) => {
                                handleChangeAccountSalesData(event, "AccountId");
                                setBalanceAmount(event?.amount);
                              }}
                              options={accountTypeDropdownOption}
                              value={accountTypeDropdownOption?.find(
                                (option) => option?.value == accountId
                              )}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              className="custom-search-select"
                            />
                          </div> */}

                    {balanceAmount && (
                      <div className="p-2 col-md-12">
                        <div className="d-flex flex-column">
                          <div className="p-1">
                            <label className="col-form-label">Balance: </label>
                          </div>
                          <div className="p-1">
                            <span>
                              <strong>{balanceAmount}</strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {selectedReceiveDropdown != 6 && (
                  <>
                    {/* <div className="p-2 col-md-12"> */}
                    <div className="p-2 col-md-12">
                      <label className="col-form-label">Tags:</label>
                      <Select
                        id="Tags"
                        name="Tags"
                        onChange={(event) => {
                          handleChangeAccountSalesData(event, "Tags");
                        }}
                        options={tagsDropdownOption}
                        value={tagsDropdownOption?.filter((obj) =>
                          selectedtags?.includes(obj.value)
                        )}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        isMulti={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="custom-search-select"
                      />
                    </div>
                    {/* </div> */}

                    <div className="p-2 col-md-12">
                      <label className="col-form-label">Receipt:</label>
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="Receipt"
                        name="Receipt"
                        onChange={handleFileChange}
                      />
                      {FileUrl && (
                        <Link to={FileUrl} target="_blank">
                          Attachment Link
                        </Link>
                      )}
                    </div>
                  </>
                )}

                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4 ||
                  selectedReceiveDropdown == 5 ||
                  selectedReceiveDropdown == 7) && (
                  <>
                    {/* <div className="d-flex flex-row"> */}

                    {(selectedReceiveDropdown == 2 ||
                      selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 5 ||
                      selectedReceiveDropdown == 7) && (
                      <div className="p-2 col-md-12">
                        <label className="col-form-label">Ref no.</label>
                        <input
                          type="text"
                          id="referenceno"
                          name="referenceno"
                          placeholder="Reference No."
                          className="form-control form-control-sm"
                          value={refrenceno}
                          onChange={(event) => {
                            handleChangeAccountSalesData(event, "referenceno");
                          }}
                        />
                      </div>
                    )}

                    {(selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 2 ||
                      selectedReceiveDropdown == 3 ||
                      selectedReceiveDropdown == 4 ||
                      selectedReceiveDropdown == 5 ||
                      selectedReceiveDropdown == 7) && (
                      <>
                        <div className="p-2 col-md-12">
                          <label className="col-form-label">
                            {selectedReceiveDropdown == 1
                              ? "Purchase Order Date"
                              : selectedReceiveDropdown == 2
                              ? "Receive Date"
                              : selectedReceiveDropdown == 3
                              ? "Return Date"
                              : selectedReceiveDropdown == 5
                              ? "Payment Date"
                              : selectedReceiveDropdown == 4
                              ? "Transfer Date"
                              : selectedReceiveDropdown == 7
                              ? "Expense Date"
                              : ""}
                          </label>
                          <div>
                            {" "}
                            {/* className="form-group" */}
                            {/* <Flatpickr
                              type="date"
                              id="receivingDate"
                              name="receivingDate"
                              placeholder="Select Date"
                              className="form-control form-control-sm"
                              value={
                                moment(receivingDate).format(
                                  "YYYY-MM-DDT00:00:00.000"
                                ) + "Z"
                              }
                              onChange={(event) =>
                                handleChangeAccountSalesData(
                                  event,
                                  "receivingDate"
                                )
                              }
                              options={{
                                dateFormat: "m/d/Y",
                                altInput: true,
                                altFormat: "m/d/Y",
                              }}
                            /> */}

                            <CommonDatePicker FinalDate={receivingDate} handleDateChange={handledatechange}/>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Due Date */}
                    {selectedReceiveDropdown == 2 && (
                      <>
                        {/* Terms  */}
                        <div className="p-2 col-md-12">
                          <label className="col-form-label">Terms:</label>
                          <Select
                            id="TermsID"
                            name="TermsID"
                            onChange={(event) =>
                              handleChangeAccountSalesData(event, "TermsID")
                            }
                            value={termsDropdownOption.find(
                              (option) => option?.value == termsId //selectedTerm
                            )}
                            options={termsDropdownOption}
                            backspaceRemovesValue={false}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            className="custom-search-select"
                          />
                        </div>

                        <div className="p-2 col-md-12">
                          <label className="col-form-label">Due Date:</label>
                          {/* <input
                            type="date"
                            id="DueDate"
                            name="DueDate"
                            className="form-control form-control-sm"
                            value={moment(
                              dueDate == ""
                                ? moment(new Date()).format("yyyy-MM-DD")
                                : dueDate
                            ).format("yyyy-MM-DD")}
                            onChange={(event) =>
                              handleChangeAccountSalesData(event, "DueDate")
                            }
                            />  */}

                                <CommonDatePicker FinalDate={dueDate == ""
                                ? moment().format("MM-DD-YYYY")
                                : dueDate} handleDateChange={handleduedatechange}/>
                        </div>
                      </>
                    )}

                    {/* {(selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 3) && (
                      <>
                     
                        <div className="p-2 col-md-12 ">
                          <label className="col-form-label">
                            Ship to Customer:
                          </label>
                          <Select
                            id="ShipToCustomer"
                            name="ShipToCustomer"
                            onChange={(event) => {
                              handleChangeAccountSalesData(
                                event,
                                "ShipToCustomer"
                              );
                            }}
                            value={customersDropdownOption.find(
                              (option) => option?.value == shipToCustomer
                            )}
                            options={customersDropdownOption}
                            backspaceRemovesValue={false}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            className="custom-search-select"
                          />
                        </div>

                        <div className="p-2 col-md-12">
                          <label className="col-form-label">Ship Via:</label>
                          <input
                            type="text"
                            id="ShipVia"
                            name="ShipVia"
                            placeholder="Ship Via"
                            className="form-control form-control-sm"
                            value={shipVia}
                            onChange={(event) =>
                              handleChangeAccountSalesData(event, "ShipVia")
                            }
                          />
                        </div>
                      </>
                    )} */}

                    {(selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 3) && (
                      <>
                        {/* Ship to Customer: */}
                        <div className="p-2 col-md-12 ">
                          <label className="col-form-label">
                            Ship to Customer:
                          </label>
                          <Select
                            id="ShipToCustomer"
                            name="ShipToCustomer"
                            onChange={(event) => {
                              handleChangeAccountSalesData(
                                event,
                                "ShipToCustomer"
                              );
                            }}
                            value={customersDropdownOption.find(
                              (option) => option?.value == shipToCustomer
                            )}
                            options={customersDropdownOption}
                            backspaceRemovesValue={false}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            className="custom-search-select"
                          />
                        </div>

                        {/* Ship Via: */}
                        <div className="p-2 col-md-12">
                          <label className="col-form-label">Ship Via:</label>
                          <input
                            type="text"
                            id="ShipVia"
                            name="ShipVia"
                            placeholder="Ship Via"
                            className="form-control form-control-sm"
                            value={shipVia}
                            onChange={(event) =>
                              handleChangeAccountSalesData(event, "ShipVia")
                            }
                          />
                        </div>
                      </>
                    )}

                    {/* </div> */}
                  </>
                )}
              </div>
            </div>

            <div className="card col-md-12">
              <div className="card-body">
                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4) && (
                  <div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          Discount all Items by Percent (%):
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="entirediscount"
                          name="entirediscount"
                          placeholder="Discount"
                          className="form-control form-control-sm"
                          value={entireReceivingDiscount}
                          onChange={handleEntireReceivingDiscountChange}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          Discount Entire Receiving:
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="number"
                          id="discount"
                          name="discount"
                          placeholder="Discount"
                          className="form-control form-control-sm"
                          value={commonDiscount}
                          onChange={handleCommonDiscountChange}
                          // readOnly={true}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          Discount Comment:
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="comment"
                          name="comment"
                          placeholder="Comment"
                          className="form-control form-control-sm"
                          value={discountComment}
                          onChange={handleChangeDiscountComments}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label
                          className="col-form-label"
                          name="SubTotal"
                          id="SubTotal"
                        >
                          Sub Total:
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="SubTotal"
                          name="SubTotal"
                          className="form-control form-control-sm"
                          // value={Number(totalRef.current).toFixed(2)}
                          value={
                            paramObject.id !== undefined
                              ? Number(totalRef.current).toFixed(2)
                              : Number(
                                  (LStotalAmt == undefined ? 0 : LStotalAmt) -
                                    commonDiscount
                                ).toFixed(2)
                          }
                        />
                        {/* {totalRef.current.toFixed(2)} */}
                        {/* {totalRef.current} */}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-2">
                  <div className="col-md-6">
                    <div className="amount-box">
                      <div
                        className="amount-box-header col-form-label align-center"
                        name="Total"
                        id="Total"
                      >
                        Total
                      </div>
                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5 ||
                        selectedReceiveDropdown == 7) && (
                        <div className="amount-box-content">
                          <div
                            className={`amount-box-value ${
                              paramObject.id == undefined
                                ? selectedReceiveDropdown == 5 ||
                                  selectedReceiveDropdown == 7
                                  ? amountForVendor?.length < 9
                                    ? "p"
                                    : amountForVendor?.length < 11
                                    ? "p-20"
                                    : "p-17"
                                  : Number(LStotalAmt) < 999999
                                  ? "p"
                                  : Number(LStotalAmt) < 99999999
                                  ? "p-20"
                                  : "p-17"
                                : Number(totalRef.current) < 999999
                                ? "p"
                                : Number(totalRef.current) < 99999999
                                ? "p-20"
                                : "p-17"
                            }`}
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            {paramObject.id === undefined ? (
                              selectedReceiveDropdown == 5 ||
                              selectedReceiveDropdown == 7 ? (
                                <>${amountForVendor}</>
                              ) : (
                                <>
                                  $
                                  {LStotalAmt == undefined
                                    ? 0
                                    : (LStotalAmt - commonDiscount)?.toFixed(2)}
                                </>
                              )
                            ) : (
                              <>{parseFloat(totalRef.current).toFixed(2)}</>
                            )}
                            {/* {totalRef.current.toFixed(2)}  */}
                            {/* {parseFloat(totalRef.current).toFixed(2)} */}
                          </div>
                        </div>
                      )}
                      {/* {selectedReceiveDropdown == 5|| selectedReceiveDropdown == 7  && (
                        <div className="amount-box-content">
                          <div
                            className="amount-box-value"
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            

                      
                          </div>
                        </div>
                      )} */}
                      {selectedReceiveDropdown == 6 && (
                        <div className="amount-box-content">
                          <div
                            className="amount-box-value"
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            {isNaN(parseFloat(paymentAmount))
                              ? "0.00"
                              : parseFloat(paymentAmount).toFixed(2)}
                            {/* {parseFloat(paymentAmount).toFixed(2)} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* For Total Items and Total Quantity */}
                  <div className="col-md-6">
                    {selectedReceiveDropdown == 1 ||
                    selectedReceiveDropdown == 2 ||
                    selectedReceiveDropdown == 3 ||
                    selectedReceiveDropdown == 4 ||
                    selectedReceiveDropdown == 5 ||
                    selectedReceiveDropdown == 6 ||
                    selectedReceiveDropdown == 7 ? (
                      <div className="row mt-3">
                        {(selectedReceiveDropdown == 1 ||
                          selectedReceiveDropdown == 2 ||
                          selectedReceiveDropdown == 3 ||
                          selectedReceiveDropdown == 4) && (
                          <div>
                            <div className="col-md-12">
                              <label className="col-form-label">
                                Total Item:
                              </label>
                              <span className="ms-5">{statenew.length}</span>
                            </div>

                            <div className="col-md-12">
                              <label className="col-form-label">
                                Total Quantity:
                              </label>
                              {paramObject.id == undefined ? (
                                <span className="ms-4">
                                  {LSItemtotalQty == undefined
                                    ? 0
                                    : LSItemtotalQty}
                                </span>
                              ) : (
                                <span className="ms-4">{totalQuantity}</span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="amount-box">
                        <div className="amount-box-header">Amount Due</div>
                        <div className="amount-box-content">
                          <div className="amount-box-value1">
                            {parseFloat(dueAmount).toFixed(2)}
                            {/* {dueAmount.toFixed(2)} */}
                            {/* ${(totalRef.current - totalRef.current).toFixed(2)} */}
                            {/* $0.00 */}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* For Payment Method */}
                <div>
                  {statenew && statenew.length > 0 ? (
                    <div>
                      {selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 2 ||
                      selectedReceiveDropdown == 3 ||
                      selectedReceiveDropdown == 4 ||
                      selectedReceiveDropdown == 5 ||
                      selectedReceiveDropdown == 6 ||
                      selectedReceiveDropdown == 7 ? (
                        ""
                      ) : (
                        <ul className="list-group payments">
                          {payments.map(
                            (payment, index) =>
                              deletedPaymentIndex !== index && (
                                <li
                                  key={index}
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                  <Link
                                    type="button"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => handleDeletePayment(index)}
                                  >
                                    <img
                                      src={Closed}
                                      alt="img"
                                      style={{
                                        marginRight: "0.5rem",
                                        width: "0.9rem",
                                        height: "0.9rem",
                                      }}
                                    />
                                  </Link>
                                  <span className="key">
                                    <i className="icon ion-android-cancel"></i>

                                    {/* for the Insert time */}
                                    {paymentTypeMap[payment.PaymentId]}

                                    {/* // for the Update Time */}

                                    {paymentTypeMap[payment.ID]}
                                  </span>
                                  <span className="value ms-auto">
                                    {Number(payment.PaymentAmount).toFixed(2)}
                                  </span>
                                </li>
                              )
                          )}
                        </ul>
                      )}
                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5) && (
                        <div>
                          <div className="row mt-2 border-bottom">
                            <div className="col-md-6">
                              <label className="col-form-label">
                                Payment Curreny:
                              </label>
                            </div>
                            <div className="col-md-6 mb-2">
                              <Select
                                className="custom-search-select"
                                value={[{ label: "USD", value: "USD" }].find(
                                  (el) => el.value === paymentCurrency
                                )}
                                onChange={(event) =>
                                  setPaymentCurrency(event?.value)
                                }
                                options={[{ label: "USD", value: "USD" }]}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              />
                            </div>
                          </div>
                          {/* <div className="row mt-2 border-bottom">
                            <label className="form-label">
                              Add Coupon Codes
                            </label>
                            <div className="input-group mb-2">
                              <span className="input-group-text">
                                <i className="fa fa-tag"></i>
                              </span>

                              <input
                                className="form-control"
                                id="CouponCode"
                                name="CouponCode"
                                onChange={handleChangeCupon}
                                value={couponCode}
                              />
                            </div>
                          </div> */}
                        </div>
                      )}

                      <div className="row mt-2 border-bottom">
                        {selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5 ||
                        selectedReceiveDropdown == 6 ||
                        selectedReceiveDropdown == 7 ? (
                          <div>
                            <div className="d-flex justify-content-center">
                              <div className="col-md-12 mb-2">
                                {/* {receivingTypeId === 2 && restirctedit == 1 ? (
                                  ""
                                ) : ( */}
                                <button
                                  className="btn btn-outline-primary w-100"
                                  data-bs-target="#SuspendedModal"
                                  data-bs-toggle="modal"
                                  // onClick={() => {
                                  //   // handleSuspendedPopup();
                                  //   handleCompleteSale("suspend");
                                  // }}
                                  // onClick={handleSuspend}
                                >
                                  {selectedReceiveDropdown == 1 && (
                                    <div className="d-inline-flex align-items-center">
                                      <i class="fas fa-solid fa-pause me-1"></i>
                                      Generate Purchase Order
                                    </div>
                                  )}
                                  {selectedReceiveDropdown == 2 && (
                                    <div className="d-inline-flex align-items-center">
                                      <i class="fas fa-solid fa-pause me-1"></i>
                                      Complete Receiving
                                    </div>
                                  )}
                                  {selectedReceiveDropdown == 3 && (
                                    <div className="d-inline-flex align-items-center">
                                      <i class="fas fa-solid fa-pause me-1"></i>
                                      Complete Return
                                    </div>
                                  )}
                                  {selectedReceiveDropdown == 4 && (
                                    <div
                                      className="d-inline-flex align-items-center"
                                      // onClick={() => showLocationError()}
                                    >
                                      <i class="fas fa-solid fa-pause me-1"></i>
                                      Complete Transfer
                                    </div>
                                  )}
                                  {(selectedReceiveDropdown == 5 ||
                                    selectedReceiveDropdown == 6 ||
                                    selectedReceiveDropdown == 7) && (
                                    <div className="d-inline-flex align-items-center">
                                      <i class="fas fa-solid fa-pause me-1"></i>
                                      Save
                                    </div>
                                  )}
                                </button>
                                {/* )} */}

                                {selectedReceiveDropdown == 4 &&
                                  !showTranser && (
                                    <div style={{ textAlign: "center" }}>
                                      <label className="col-form-label">
                                        OR
                                      </label>
                                    </div>
                                  )}
                                {selectedReceiveDropdown == 4 &&
                                  !showTranser && (
                                    <div className="col-md-12 mb-2">
                                      <button
                                        className="btn btn-outline-primary w-100"
                                        // data-bs-target="#SuspendedModal"
                                        // data-bs-toggle="modal"
                                        type="button"
                                        onClick={handleIsComplete}
                                      >
                                        Send Transfer Request
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <label className="col-form-label">
                              Add Payment
                            </label>
                            <div className="mb-3">
                              {paymentTypeDropdown &&
                                paymentTypeDropdown.map((option, index) => (
                                  <button
                                    key={index}
                                    type="button"
                                    // className={`btn btn-outline-primary me-1 mb-1 ${selectedPaymentId  === option.ID ? 'active btn-primary' : ''}`}
                                    className={`btn btn-outline-primary me-1 mb-1 ${
                                      selectedPayment &&
                                      selectedPayment.id === option.ID
                                        ? "active btn-primary"
                                        : ""
                                    }`}
                                    // className={`btn btn-outline-primary me-1 mb-1 ${selectedPayment === option.ID ? 'active btn-primary' : ''}`}
                                    onClick={() =>
                                      handlePayment(
                                        option.Paymenttypename,
                                        option.ID,
                                        option.Paymenttypename
                                      )
                                    }
                                  >
                                    {option.Paymenttypename}
                                  </button>
                                ))}

                              <div className="input-group mt-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="0.00"
                                  value={amountToSubtract}
                                  onChange={handleAmountChange}
                                />
                                {dueAmount === parseFloat(amountToSubtract) ? (
                                  <span className="input-group-append">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      data-bs-target="#CompleteModal"
                                      data-bs-toggle="modal"
                                      // onClick={() => {
                                      //   handleCompleteSale("complete");
                                      //   handleSubmit();
                                      // }}
                                    >
                                      Complete Receiving
                                    </button>
                                  </span>
                                ) : (
                                  <span className="input-group-append">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        handleCompleteSale("complete");
                                      }}
                                    >
                                      Add Payment
                                    </button>
                                  </span>
                                )}
                              </div>

                              {/* <div className="input-group mt-2">
                     <input
                       type="text"
                       className="form-control"
                       placeholder="0.00"
                       value={amountToSubtract}
                       onChange={handleAmountChange}
                     />
                     <span className="input-group-append">
                       <button
                         type="button"
                         className="btn btn-primary"
                         onClick={() => {
                           isAddPaymentEnabled ? handleSubmit() : handleCompleteSale();
                         }}
                         // disabled={!isAddPaymentEnabled}
                       >
                         {isAddPaymentEnabled ? "Add Payment" : "Complete Sale"}
                       </button>
                     </span>
                   </div> */}
                            </div>
                          </div>
                        )}
                        {/* Custom Field Binding */}

                        {customFields.map((data, index) => (
                          <>
                            <div className="row mt-2">
                              <label
                                className="col-form-label col-md-4 form-label  mb-2"
                                key={index}
                              >
                                {data.Name}
                              </label>
                              <div className="col-md-8">
                                {data.TypeName === "Text" ? (
                                  <input
                                    key={index}
                                    type="text"
                                    className="form-control"
                                    onChange={(event) => {
                                      // handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                  />
                                ) : data.TypeName === "E-Mail" ? (
                                  <input
                                    key={index}
                                    type="email"
                                    className="form-control"
                                    onChange={(event) => {
                                      // handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                  />
                                ) : data.TypeName === "Dropdown" ? (
                                  <>
                                    <Select
                                      key={index}
                                      id={data.TypeName}
                                      name={data.Id}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      onChange={(event) => {
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Id
                                        );
                                        setSelectedCustomField(event, index);
                                      }}
                                      options={data.Optionvalue.split(",").map(
                                        (option) => ({
                                          label: option,
                                          value: option,
                                          selectedValue: data.Name,
                                          selected: option === data.Id,
                                        })
                                      )}
                                      placeholder="Select"
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      // defaultValue={
                                      //   [data.Id] !== null && [data.Id] !== ""
                                      //     ? {
                                      //         label: [data.Id],
                                      //         value: [data.Id],
                                      //       }
                                      //     : ""
                                      // }
                                    />
                                  </>
                                ) : data.TypeName === "Checkbox" ? (
                                  <input
                                    key={index}
                                    className="form-check-input form-control"
                                    // style={{
                                    //   width: "1.5em",
                                    //   height: "1.5em",
                                    // }}
                                    type="checkbox"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                      handleChange(event);
                                    }}
                                    onInput={handleSelectCustomCheckBox}
                                  />
                                ) : data.TypeName === "Website" ? (
                                  <input
                                    key={index}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                  />
                                ) : data.TypeName === "PhoneNumber" ? (
                                  <input
                                    key={index}
                                    type="number"
                                    className="form-control form-control-sm"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : data.TypeName === "Date" ? (
                                  <input
                                    key={index}
                                    className="form-control form-control-sm"
                                    type="date"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : data.TypeName === "Image" ? (
                                  <>
                                    {/* <button onClick={()=> (console.log("selectedCustomImage",selectedCustomImage))}>Check</button> */}
                                    <div className="row">
                                      <FileInput
                                        type="file"
                                        key={index}
                                        className="form-control form-control-sm"
                                        id={data.TypeName}
                                        name={data.Id}
                                        value={selectedCustomImage}
                                        accept="image/*"
                                        handleChange={(event) => {
                                          _handleFileChange(event, index);
                                          handleCustomFieldsValues(
                                            event,
                                            data.TypeName,
                                            data.Name
                                          );
                                        }}
                                      />
                                    </div>
                                    <img
                                      src={`${
                                        formValues[data.Id]
                                          ? formValues[data.Id]
                                          : selectedCustomImage
                                      }`}
                                      className="ImagePreviewSize mt-3 mb-3"
                                    />

                                    {/* <div className="row">
                                      <div className="mt-2">
                                        <div
                                          className={`${
                                            [data.Id]
                                              ? ""
                                              : selectedCustomImage
                                              ? ""
                                              : "d-none"
                                          } form-group row`}
                                        >
                                          <label className="col-form-label col-md-2 form-label"></label>
                                          <div>
                                            <img
                                              src={`${
                                                [data.Id]
                                                  ? [data.Id]
                                                  : selectedCustomImage
                                              }`}
                                              alt="Category Image"
                                              // onClick={()=> (console.log("selectedCustomImage",data.Id))}
                                              className="ImagePreviewSize"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                                  </>
                                ) : data.TypeName === "File" ? (
                                  <FileInput
                                    type="file"
                                    key={index}
                                    className="form-control form-control-sm"
                                    id={data.TypeName}
                                    name={data.Id}
                                    value={selectedCustomFile}
                                    handleChange={(event) => {
                                      // _handleFileChange(event, index);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </>
                        ))}

                        {/* <div className="form-group">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="ChangeReceivingDate"
                              // onChange={handleCheckboxChange}
                            />
                            <label className="form-check-label">
                              Change receiving date
                            </label>
                          </div>
                        </div> */}
                        {/* {showDateInput && (
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="date"
                              id="receivingDate"
                              name="receivingDate"
                            />
                          </div>
                        )} */}
                      </div>

                      <div className="form-group mt-2">
                        <textarea
                          className="form-control"
                          id="exampleTextarea"
                          name="exampleTextarea"
                          rows="3"
                          placeholder="Comments"
                          value={comment} // Set the value to the comment state variable
                          onChange={handleChangeComment}
                          // onChange={handleChangeComments}
                        ></textarea>
                      </div>
                      {/* <div className="form-group">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="showCommentsOnReceipt"
                          />
                          <label className="form-check-label">
                            Show comments on receipt
                          </label>
                        </div>
                      </div> */}
                    </div>
                  ) : null}
                  {/* This Button is only for the Store Account */}
                  {selectedReceiveDropdown == 6 && statenew.length === 0 && (
                    <button
                      className="btn btn-outline-primary ms-1 mb-2 w-100"
                      // data-bs-target="#SuspendedModal"
                      data-bs-target={selectedOption ? "#SuspendedModal" : ""}
                      onClick={(e) =>
                        selectedOption
                          ? ""
                          : toastError("Please select a supplier")
                      }
                      data-bs-toggle="modal"
                    >
                      <div className="d-inline-flex align-items-center">
                        <i class="fas fa-solid fa-pause me-1"></i>
                        Save
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal ${modal ? "d-block" : ""}`}
        tabIndex="-1"
        style={{ background: "rgba(0,0,0,0.2)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">Confirmation</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <p className="col-form-label">
                    Payment transaction has been intiated, so you can't change
                    the Receiving Type
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setModal(false)}
              >
                Ok
              </button>
              {/* <button
                type="button"
                className="btn btn-secondary"
                // onClick={handleCancelDelete}
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <CompleteSaleModal
        handleCompleteSale={handleCompleteSale}
        handleSubmit={handleSubmit}
        // selectedReceiveDropdown={selectedReceiveDropdown}
        disabled={selectedOption == null ? true : false}
      />
      {/* <FilterModal callback={callbackItemGrid} runApi={runApi} /> */}
      <FilterModal
        callback={callbackItemGrid}
        runApi={runApi}
        closepopup={() => setRunApi(false)}
      />
      <CancelConfirmation handleCancelPopup={handleCancelPopup} />
      <SuspendedConfirmation handleSuspend={handleSuspend} type="Receiving" />

      {/* temp data comment for testing
      <ItemsDetailsModal ItemsDetails={itemsDetailsData} /> */}
      <ItemsDetailsModal id={itemsDetailsData ? itemsDetailsData.ItemId : 0} />
      <LookupReceiptModal />
      <HistoryModel model="receiving" id={showHistoryList ? 1 : 0} />
    </>
  );
};

// Item SearchableDropdown
const SearchableDropdown = ({
  SupplierID,
  callback,
  disabled,
  selectedReceiveDropdown,
  readonly,
  value,
  isExpense,
  toggele,
  searchItemInputRef,
}) => {
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const Id = localStorage.getItem("ID");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [entervalue, setEnterValue] = useState(0);
  const [tableData, setTableData] = useState([]);
  console.log(toggele, "7777");

  //For Toaster
  const [show, setShow] = useState(false);
  const [barcodedisplay, setBarcodeDisplay] = useState("");

  //   useScanDetection({
  //     onComplete: setValue,
  //     minLength: 13 // EAN13
  // });

  useEffect(() => {
    //  fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, selectedReceiveDropdown]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);
      let isReceiving = 1;
      let itemsearchtype = "";
      if (selectedReceiveDropdown == 1) {
        isReceiving = 0;
      }

      console.log(selectedReceiveDropdown, "selectedReceiveDropdown");

      if (value == 5) {
        itemsearchtype = "vendorcredit";
      }

      if (toggele == true) {
        itemsearchtype = "vendorcredit";
      }
      await axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            inputValue
          )}&iscategory=${selectedReceiveDropdown}&supplierid=${
            SupplierID > 0 ? SupplierID : 0
          }&locationid=${location}&customerid=0&itemsearchtype=${itemsearchtype}&isservice=${0}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          console.log("ressssspsosossns", response.data.ResponseData);
          if (response.data.ResponseData?.length > 0) {
            const data = response.data?.ResponseData;
            // const barcodedata= data.find((i,obj)=>{
            //    return obj.Itemnumber==inputValue
            // })
            // if(entervalue==1){
            //   setSuggestions([])
            //   setTableData([...tableData,barcodedata])
            // }else{
            // if (data[0].ItemId > 0) {
            //   setSuggestions(data);
            // }

            // if(barcodedisplay =="Enter") {
            //   handleInputClick(
            //     data[0].ItemId,
            //     data[0].ItemName,
            //     data[0].VariationName,
            //     data[0].CostPrice,
            //     data[0].UnitPrice,
            //     data[0].Itemquantity,
            //     data[0].Description,
            //     data[0].VariationId,
            //     data[0].AttributeId,
            //     data[0].Module,
            //     data[0].CategoryID,
            //     data[0].CategoryName,
            //     data[0].Itemnumber,
            //     data[0].Allowaltdescription,
            //     data[0].IsItemserialnumber,
            //     data[0].VariationQuantity)
            // }else{
            //   setSuggestions(data);
            // }
            console.log(data, "testdata1");
            const itemarray = data[0]?.Itemnumber
              ? data[0]?.Itemnumber?.split(",")
              : "";
            if (data.length === 1 && itemarray.includes(inputValue)) {
              handleInputClick(
                data[0].ItemId,
                data[0].ItemName,
                data[0].VariationName,
                data[0].CostPrice,
                data[0].UnitPrice,
                data[0].Itemquantity === null ? 0 : data[0].Itemquantity,
                data[0].Description,
                data[0].VariationId,
                data[0].AttributeId,
                data[0].Module,
                data[0].CategoryID,
                data[0].CategoryName,
                data[0].Itemnumber,
                data[0].Allowaltdescription,
                data[0].IsItemserialnumber,
                data[0].VariationQuantity,
                data[0].QuickbookId,
                data[0].AccountTypeName
              );
              // setTableData([...tableData,...data])
            } else {
              console.log(data, "testdata2");
              setSuggestions(data);
            }
            // }
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  console.log(suggestions, "suggestions");

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true && !isExpense) {
      toastError("Please Select a Supplier First");
      // toastError(
      //   isExpense
      //     ? "Please Select a Payee First"
      //     : "Please Select a Supplier First"
      // );
    }
  };

  const [cursor, setcursor] = useState(0);

  let barcodeScan = "";

  const handleKeyDown = (e) => {
    console.log("log : e.keyCode =>", e.keyCode, e.key, e.target.value);
    // console.log("log : e.keyCode =>", e);

    // barcodeScan += e.key;

    // console.log(barcodeScan.length,"barcodeScanlength")

    // if(e.keyCode === 13 && barcodeScan.length > 3 ) {
    //   setBarcodeDisplay(barcodeScan)
    //   return
    // }

    console.log(suggestions, "suggestionsaa");

    if (e.keyCode === 13 || e.key === "Enter") {
      const item = suggestions[cursor];
      handleInputClick(
        item.ItemId,
        item.ItemName,
        item.VariationName,
        item.CostPrice,
        item.UnitPrice,
        item.Itemquantity,
        item.Description,
        item.VariationId,
        item.AttributeId,
        item.Module,
        item.CategoryID,
        item.CategoryName,
        item.Itemnumber,
        item.Allowaltdescription,
        item.IsItemserialnumber,
        item.VariationQuantity,
        item.QuickbookId,
        item.AccountTypeName
      );
    } else if (e.keyCode === 38 && cursor > 0) {
      setcursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
      setcursor(cursor + 1);
    }

    // setTimeout(()=>{
    //   barcodeScan=""
    // },100)
  };
  console.log("log :  cursor =>", cursor);

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pCostPrice,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pQuickbookID,
    AccountTypeName

    // pItemKitId
  ) => {
    console.log("log : call function");
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {
              console.log("Suggestions", suggestions);
            });

            let tablesDatas = data.map((item) => ({
              ReceivingItemID: 0,
              ItemId: item.ItemId,
              ReceivingId: 0,
              CostPrice: item.CostPrice,
              UnitPrice: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: selectedReceiveDropdown === 1 ? 0 : 1,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              Total: item.CostPrice,
              CategoryName: item.CategoryName,
              Itemnumber: item.Itemnumber,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              quickbookid: item.QuickbookID,
              AccountTypeName: item.AccountTypeName,
            }));

            setTableData([tablesDatas[0]]); // modify this line
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        ReceivingItemID: 0,
        ItemId: pItemId,
        ReceivingId: 0,
        CostPrice: selectedReceiveDropdown === 1 ? 0 : pCostPrice,
        UnitPrice: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: 1,
        ItemCurrentQuantity: pItemQuantity, // pItemQuantity,
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        Total: pCostPrice,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        Itemnumber: pItemnumber,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        itemquickbookid: pQuickbookID,
        AccountTypeName: AccountTypeName,
      };

      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    console.log(tableData, "tableData===123");
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);

  return (
    <div className="">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>

            <input
              ref={searchItemInputRef}
              type="text"
              className={`form-control form-control-sm ${
                isExpense ? "" : "border-size-input"
              }`}
              placeholder={
                selectedReceiveDropdown === 1
                  ? "Select category"
                  : "Type item name or scan barcode"
              }
              value={inputValue}
              onChange={handleInputChange}
              onClick={handleToast}
              disabled={disabled}
              readOnly={isExpense ? false : readonly}
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul
              className="dropdown-menu show dropdown-suggestion"
              style={{ overflow: "auto", width: "139% ", maxWidth: "600px" }}
            >
              {suggestions.map((item, index) => (
                <li
                  // className="border-bottom"
                  className={
                    cursor === index ? "border-bottom active" : "border-bottom"
                  }
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.CostPrice,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity,
                      item.QuickbookId,
                      item.AccountTypeName
                      // item.ItemKitId
                    )
                  }
                >
                  {isExpense ? (
                    <div
                      key={item.ItemId}
                      // to="/manage-receiving?expense=true"
                      // href="#"
                      // className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      className={
                        cursor === index
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      data-name={item.ItemName?.toLowerCase()}
                    >
                      <img
                        src={item.ImageName}
                        onError={(e) => {
                          e.currentTarget.src = Noimage;
                        }}
                        alt={item.ItemName}
                        className="img-thumbnail rounded-circle m-2"
                        width="55"
                        height="55"
                      />

                      <div className="customer-info">
                        <strong className="name word-break-data">
                          {item.ItemName}{" "}
                          {item.VariationName ? `(${item.VariationName})` : ""}
                          <div
                            className="ml-auto sync-label "
                            // variant="success"
                            // style={{ position: "absolute", right: "5px" }}
                          >
                            <div style={{}}> {item.Module}</div>
                          </div>
                          {/* <div style={{marginTop:"20px"}}>
           {item.QuickbookId > 0 && (
                  <div style={{ marginTop:"30px"}}
                    className="sync-label">
                    <i
                      className="fa fa-circle"
                      style={{ fontSize: "14px", color: "green" }}
                    ></i> {" "}
                    QB Sync
                  </div>
                )}
           </div> */}
                        </strong>
                        {item.Module === "Accounts" ? (
                          <>
                            <div>Account Type: {item.AccountTypeName}</div>
                            <div>{item.AccountDeatilsTypeName}</div>
                          </>
                        ) : (
                          <>
                            <div>
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)}{" "}
                    | Promo Price:{" "}
                    {parseFloat(item.PromoPrice).toFixed(2)}| Unit
                    Price: {parseFloat(item.UnitPrice).toFixed(2)} */}
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                              Cost Price:{" "}
                              {parseFloat(item.CostPrice).toFixed(2)} | Qty:{" "}
                              {parseInt(item.Itemquantity)}
                            </div>
                            <div>Categories: {item.CategoryName}</div>
                            <div style={{ display: "flex", float: "right" }}>
                              {item.QuickbookId > 0 && (
                                <span>
                                  <i
                                    className="fa fa-circle"
                                    style={{ fontSize: "14px", color: "green" }}
                                  ></i>{" "}
                                  QB Sync
                                </span>
                              )}
                            </div>
                          </>
                        )}

                        {/* Add any other customer details here */}
                      </div>
                    </div>
                  ) : (
                    <div
                      key={item.ItemId}
                      // to={
                      //   isExpense
                      //    ? "/manage-receiving?expense=true"
                      //     :"/manage-receiving"
                      // }
                      // href="#"
                      // className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      className={
                        cursor === index
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      data-name={item.ItemName?.toLowerCase()}
                    >
                      <img
                        src={item.ImageName}
                        onError={(e) => {
                          e.currentTarget.src = Noimage;
                        }}
                        alt={item.ItemName}
                        className="img-thumbnail rounded-circle m-2"
                        width="55"
                        height="55"
                        style={{ height: "60px", objectFit: "contain" }}
                      />

                      <div className="customer-info w-100">
                        <strong className="name word-break-data">
                          {item.ItemName}{" "}
                          {item.VariationName ? `(${item.VariationName})` : ""}
                          {/* <Badge
                  className="ml-auto"
                  variant="primary"
                  style={{ position: "absolute", right: "5px" }}
                >
                  {item.Module}
                </Badge> */}
                        </strong>
                        {item.Module === "Accounts" ? (
                          <>
                            <div>Account Type: {item.AccountTypeName}</div>
                            <div>{item.AccountDeatilsTypeName}</div>
                          </>
                        ) : (
                          <>
                            <div>
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)}{" "}
                    | Promo Price:{" "}
                    {parseFloat(item.PromoPrice).toFixed(2)}| Unit
                    Price: {parseFloat(item.UnitPrice).toFixed(2)} */}
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                              Cost Price:{" "}
                              {parseFloat(item.CostPrice).toFixed(2)} | Qty:{" "}
                              {parseInt(item.Itemquantity)}
                            </div>
                            <div>Categories: {item.CategoryName}</div>
                            <div style={{ display: "flex", float: "right" }}>
                              {item.QuickbookId > 0 && (
                                <span>
                                  <i
                                    className="fa fa-circle"
                                    style={{ fontSize: "14px", color: "green" }}
                                  ></i>{" "}
                                  QB Sync
                                </span>
                              )}
                            </div>
                          </>
                        )}

                        {/* Add any other customer details here */}
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
};

export default ManageReceiving;
